/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: number; output: number; }
  Long: { input: number; output: number; }
  Void: { input: any; output: any; }
};

export type AccessConstraint = {
  partyRole?: InputMaybe<PartyRole>;
};

export type Address = {
  /** city is used for the city/town/village of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** ISO country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  long?: Maybe<Scalars['Float']['output']>;
  /** postal identifier for the address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** region is the state, region, or any other subdivision of the country */
  region?: Maybe<Scalars['String']['output']>;
  /** street contains the housing number and street name */
  street?: Maybe<Scalars['String']['output']>;
  /** street_additional is used for any other additional street identifying information */
  streetAdditional?: Maybe<Scalars['String']['output']>;
};

export enum AffiliateType {
  Accounting = 'Accounting',
  Investment = 'Investment'
}

export type AppInstanceChallenge = {
  deviceId: Scalars['String']['input'];
  nonce: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
  timestamp: Scalars['Long']['input'];
  userId: Scalars['String']['input'];
};

export type AppInstanceProfile = {
  appBundleId: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  appVersion: Scalars['String']['input'];
  deviceModel: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  deviceOs: Scalars['String']['input'];
  deviceOsVersion: Scalars['String']['input'];
};

export enum ArrivalContext {
  ClientPays = 'ClientPays',
  ClientPaysComposable = 'ClientPaysComposable',
  ReportsBuilder = 'ReportsBuilder',
  ResetClientPays = 'ResetClientPays',
  TransactionReview = 'TransactionReview'
}

export type BankAccount = {
  accountIdMask: Scalars['String']['output'];
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  isAutoPayout: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
};

export type BeginLogin = {
  requiresSSO: Scalars['Boolean']['output'];
  ssoIdentityProviderId?: Maybe<Scalars['String']['output']>;
  ssoIssuerURL?: Maybe<Scalars['String']['output']>;
  ssoOrganizationId?: Maybe<Scalars['String']['output']>;
};

export type BillPaymentPreview = {
  amount: MonetaryValue;
  billId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: BillPaymentPreviewSegment;
  payerCompanyName: Scalars['String']['output'];
  payerEmailAddress: Scalars['String']['output'];
  vendor: PartyPreview;
};

export type BillPaymentPreviewSegment = {
  collectionId: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CardBillingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
};

export enum CardPaymentResultStatus {
  /** Payment was successful */
  Authorised = 'Authorised',
  /** An error occurred */
  Error = 'Error',
  /** Additional action required (e.g., 3DS) */
  Pending = 'Pending',
  /** Payment is being processed */
  Received = 'Received',
  /** Payment was refused */
  Refused = 'Refused',
  Unknown = 'Unknown'
}

export type CategoryPreview = {
  displayKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: CategoryType;
};

export enum CategoryType {
  Assets = 'Assets',
  CostOfGoodsSold = 'CostOfGoodsSold',
  Equity = 'Equity',
  Expenses = 'Expenses',
  Income = 'Income',
  Liabilities = 'Liabilities',
  OtherExpenses = 'OtherExpenses',
  OtherIncome = 'OtherIncome',
  UnknownType = 'UnknownType'
}

export type ConfirmationToken = {
  token: Scalars['String']['output'];
};

export type Contact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCard = {
  /** Card brand (e.g., visa, mastercard, amex) */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Expiration month (1-12) */
  cardExpiryMonth?: Maybe<Scalars['Long']['output']>;
  /** Expiration year (e.g., 2025) */
  cardExpiryYear?: Maybe<Scalars['Long']['output']>;
  /** Last 4 digits of the card number */
  cardLastFour?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
};

export type Customer = {
  address?: Maybe<CustomerAddress>;
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerType: ProviderType;
};

export type CustomerAddress = {
  address?: Maybe<Address>;
  id: Scalars['String']['output'];
};

export type CustomerSummary = {
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Date = {
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DateInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Discount = {
  categoryId?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  fixedDiscountAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  providerType: ProviderType;
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};

export enum DisplayEntry {
  Credit = 'Credit',
  Debit = 'Debit',
  TransferCredit = 'TransferCredit',
  TransferDebit = 'TransferDebit',
  Unknown = 'Unknown'
}

export type DocumentDownload = {
  url: Scalars['String']['output'];
};

export type EmployeeLegalEntityRole = {
  legalEntityId: Scalars['String']['output'];
  role?: Maybe<Role>;
};

export type EntityLegalEntity = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityOrganization = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityUser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum Flow {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  UnknownFlow = 'UnknownFlow'
}

export type Identity = {
  domain?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  provider: OAuthService;
};

export type InputMonetaryValue = {
  amount: Scalars['Long']['input'];
  currencyMultiplier: Scalars['Long']['input'];
  iso4217CurrencyCode: Scalars['String']['input'];
};

/**
 * ObjectIdentifier is a generic identifier with an enumerated kind.
 * It can be used to identify different Digits' core objects.
 */
export type InputObjectIdentifier = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};

export type InputQuantityValue = {
  quantity: Scalars['Long']['input'];
  quantityMultiplier: Scalars['Long']['input'];
};

export enum Interval {
  Biweek = 'Biweek',
  Day = 'Day',
  Hour = 'Hour',
  IntervalNone = 'IntervalNone',
  Minute = 'Minute',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export type Invitation = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invitationType: InvitationType;
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  recipient: Contact;
  role?: Maybe<Role>;
  sender?: Maybe<Contact>;
  service?: Maybe<OAuthService>;
  signupId?: Maybe<Scalars['String']['output']>;
  status: InvitationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvitationProposal = {
  createdAt: Scalars['DateTime']['output'];
  invitationId: Scalars['String']['output'];
  legalEntity?: Maybe<EntityLegalEntity>;
  organization?: Maybe<EntityOrganization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  proposalId: Scalars['String']['output'];
  proposalType: ProposalType;
  recipient?: Maybe<Contact>;
  sender?: Maybe<EntityUser>;
  status: InvitationProposalStatus;
};

export enum InvitationProposalStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Rejected = 'Rejected',
  Sent = 'Sent',
  Unknown = 'Unknown'
}

export enum InvitationStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Cancelled = 'Cancelled',
  Unknown = 'Unknown'
}

export type InvitationToken = {
  token: Scalars['String']['output'];
};

export enum InvitationType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  Passwordless = 'Passwordless',
  UnknownType = 'UnknownType'
}

export type Invoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  status: InvoiceStatus;
  statusSummary?: Maybe<InvoiceStatusSummary>;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type InvoiceBranding = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  coverURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** Result of a card payment submission */
export type InvoiceCardPaymentResult = {
  /** Action data for additional authentication (3DS) - pass to handleAction */
  actionData?: Maybe<Scalars['String']['output']>;
  /** Card brand (e.g. "visa", "mc") */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Last four digits of the card */
  cardLastFour?: Maybe<Scalars['String']['output']>;
  /** Error message if payment failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Payment confirmation ID (if successful) */
  paymentConfirmationId?: Maybe<Scalars['String']['output']>;
  /** Adyen PSP reference */
  pspReference?: Maybe<Scalars['String']['output']>;
  /** Refusal reason code from Adyen (if refused) */
  refusalReasonCode?: Maybe<Scalars['String']['output']>;
  /** Result status of the payment attempt */
  result: CardPaymentResultStatus;
};

export type InvoiceDiscount = {
  amount: MonetaryValue;
  discount: Discount;
  discountAmount?: Maybe<MonetaryValue>;
  invoiceDiscountId: Scalars['String']['output'];
};

export type InvoiceFile = {
  documentId: Scalars['String']['output'];
  fileType?: Maybe<InvoiceFileType>;
};

export enum InvoiceFileType {
  InvoicePDF = 'InvoicePDF',
  Unknown = 'Unknown'
}

export type InvoiceLineItem = {
  amount: MonetaryValue;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<QuantityValue>;
  sku?: Maybe<Scalars['String']['output']>;
  taxable: Scalars['Boolean']['output'];
  unitPrice: MonetaryValue;
};

export type InvoiceNumber = {
  invoiceNumber: Scalars['String']['output'];
};

export type InvoicePaymentDetails = {
  paymentAmount: MonetaryValue;
  paymentConfirmationId: Scalars['String']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentInstrument: PaymentInstrument;
};

/**
 * Card Payment Types
 * Adyen payment methods for card payments
 */
export type InvoicePaymentMethods = {
  /** Client key for initializing Adyen on the frontend */
  clientKey: Scalars['String']['output'];
  /** Environment (test or live) */
  environment: Scalars['String']['output'];
  /** Available payment methods as JSON string */
  paymentMethodsResponse?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  /** adding this temporarily to fix an ops issue */
  Draft = 'Draft',
  Failed = 'Failed',
  ManuallySent = 'ManuallySent',
  MarkedAsPaid = 'MarkedAsPaid',
  OnHold = 'OnHold',
  Paid = 'Paid',
  PaymentCanceled = 'PaymentCanceled',
  PaymentProcessing = 'PaymentProcessing',
  PaymentRejected = 'PaymentRejected',
  PaymentRequiresAttention = 'PaymentRequiresAttention',
  PaymentReturned = 'PaymentReturned',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Sent = 'Sent',
  Settled = 'Settled',
  Submitted = 'Submitted',
  Unknown = 'Unknown',
  UnspecifiedBillStatus = 'UnspecifiedBillStatus',
  Voided = 'Voided'
}

export type InvoiceStatusSummary = {
  internalNoteForStatus?: Maybe<Scalars['String']['output']>;
  invoiceSentDate: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoicingAddress = {
  address: Address;
  id: Scalars['String']['output'];
};

export type InvoicingProfile = {
  companyAddress: InvoicingAddress;
  companyEmail: Scalars['String']['output'];
  companyIcon?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoiceNumberFormat?: Maybe<Scalars['String']['output']>;
  invoiceNumberFormatDefault: Scalars['String']['output'];
  payoutInstrumentID: Scalars['String']['output'];
};

export type LedgerBillPreview = {
  amount: MonetaryValue;
  billId: Scalars['String']['output'];
  dueDate?: Maybe<Date>;
  externalId: Scalars['String']['output'];
  image?: Maybe<BillPaymentPreviewSegment>;
  invoiceDate?: Maybe<Date>;
  payerCompanyName: Scalars['String']['output'];
  payerEmailAddress: Scalars['String']['output'];
  vendor: LedgerBillPreviewVendor;
};

export type LedgerBillPreviewVendor = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LegalEntityRoleOptions = {
  legalEntityId: Scalars['String']['output'];
  legalEntityRoles: Array<Role>;
  organizationRoles: Array<Role>;
};

export enum LegalEntityStatus {
  Active = 'Active',
  Approved = 'Approved',
  New = 'New',
  Pending = 'Pending',
  PendingHold = 'PendingHold',
  Removed = 'Removed',
  Unknown = 'Unknown'
}

export enum MagicLinkRequestScheme {
  Digits = 'Digits',
  Https = 'Https'
}

export enum MetricType {
  COGS = 'COGS',
  Expenses = 'Expenses',
  GrossProfit = 'GrossProfit',
  Income = 'Income',
  NetIncome = 'NetIncome',
  NetOperatingIncome = 'NetOperatingIncome',
  ProfitPercentage = 'ProfitPercentage'
}

export enum MfaMethod {
  RecoveryCode = 'RecoveryCode',
  TOTP = 'TOTP',
  UnknownMfaMethod = 'UnknownMfaMethod'
}

/** MonetaryValue */
export type MonetaryValue = {
  amount: Scalars['Long']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  iso4217CurrencyCode: Scalars['String']['output'];
};

export type MoneyFlow = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['output'];
  value: MonetaryValue;
};

export type MoneyFlowInput = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['input'];
  value: InputMonetaryValue;
};

export type Mutation = {
  addSignup: PublicSignup;
  beginLogin: BeginLogin;
  /**
   * Completes a pending MFA challenge issued by a login RPC. The challengeToken
   * is the opaque value surfaced in error.extensions.error.mfa_challenge_token
   * on a FailedPrecondition response from logInEmail.
   */
  completeMfaChallenge: Session;
  createPasswordReset?: Maybe<Scalars['Void']['output']>;
  createPaymentPlaidLinkToken: PlaidLinkToken;
  createPlaidGuestBankAccountInstrument: PaymentInstrument;
  /** Handles additional actions required by Adyen (e.g., 3DS authentication) */
  handleInvoiceCardPaymentAction: InvoiceCardPaymentResult;
  /** Handles additional Adyen actions for a ledger invoice (e.g., 3DS authentication) */
  ledgerHandleInvoiceCardPaymentAction: InvoiceCardPaymentResult;
  ledgerPayInvoice: PayInvoiceSummary;
  /** Submits a card payment for a ledger invoice using encrypted card data from Adyen */
  ledgerSubmitInvoiceCardPayment: InvoiceCardPaymentResult;
  logInAppInstance: Session;
  logInEmail: Session;
  logInEmailWithAttest: Session;
  logInMagicLink: Session;
  logInOAuth: Session;
  logInSSOHandoff: Session;
  /** Support */
  logInSupport: Session;
  logOut?: Maybe<Scalars['Void']['output']>;
  logOutSupport: Session;
  payInvoice: PayInvoiceSummary;
  provisionVerificationToken: ConfirmationToken;
  registerInviteOAuth: Session;
  registerInvitePasswordless: Session;
  registerUserEmail: Session;
  registerUserEmailToken: RegistrationStatus;
  registerUserOAuth: Session;
  resetPassword: Session;
  sendAcceptedInvitationMagicLink?: Maybe<Scalars['Void']['output']>;
  sendEmailVerification?: Maybe<Scalars['Void']['output']>;
  sendMagicLinkEmail?: Maybe<Scalars['Void']['output']>;
  /** Submits a card payment for an invoice using encrypted card data from Adyen */
  submitInvoiceCardPayment: InvoiceCardPaymentResult;
  tokenRefresh: Session;
  unsubscribe?: Maybe<Scalars['Void']['output']>;
  updateSignup: PublicSignup;
  updateSignupFromOAuth: PublicSignup;
};


export type MutationAddSignupArgs = {
  attribution?: InputMaybe<SignupAttribution>;
  email: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<Persona>;
  planIntent?: InputMaybe<PlanIntent>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBeginLoginArgs = {
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteMfaChallengeArgs = {
  challengeToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  method: MfaMethod;
};


export type MutationCreatePasswordResetArgs = {
  billId?: InputMaybe<Scalars['String']['input']>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  intentId?: InputMaybe<Scalars['String']['input']>;
  ledgerBillId?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<InputObjectIdentifier>;
};


export type MutationCreatePaymentPlaidLinkTokenArgs = {
  plaidClientUserId: Scalars['String']['input'];
};


export type MutationCreatePlaidGuestBankAccountInstrumentArgs = {
  accountId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  useNewPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationHandleInvoiceCardPaymentActionArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
};


export type MutationLedgerHandleInvoiceCardPaymentActionArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  expectedAmount: InputMonetaryValue;
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
};


export type MutationLedgerPayInvoiceArgs = {
  expectedAmount: InputMonetaryValue;
  invoiceId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
};


export type MutationLedgerSubmitInvoiceCardPaymentArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  expectedAmount: InputMonetaryValue;
  holderName?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
  riskData?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLogInAppInstanceArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  challenge: AppInstanceChallenge;
  id: Scalars['String']['input'];
  profile: AppInstanceProfile;
};


export type MutationLogInEmailArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLogInEmailWithAttestArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  attestation: Scalars['String']['input'];
  challenge: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLogInMagicLinkArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationLogInOAuthArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationLogInSsoHandoffArgs = {
  clientId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationLogInSupportArgs = {
  id: Scalars['String']['input'];
};


export type MutationLogOutSupportArgs = {
  id: Scalars['String']['input'];
};


export type MutationPayInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
  receivableInvoiceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProvisionVerificationTokenArgs = {
  emailAddress: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  intentId: Scalars['String']['input'];
  object: InputObjectIdentifier;
};


export type MutationRegisterInviteOAuthArgs = {
  code: Scalars['String']['input'];
  invitationToken: Scalars['String']['input'];
  service: OAuthService;
  timezone: Scalars['String']['input'];
};


export type MutationRegisterInvitePasswordlessArgs = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  invitationToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterUserEmailArgs = {
  confirmToken: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterUserEmailTokenArgs = {
  confirmToken: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterUserOAuthArgs = {
  code: Scalars['String']['input'];
  service: OAuthService;
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};


export type MutationSendAcceptedInvitationMagicLinkArgs = {
  invitationToken: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendEmailVerificationArgs = {
  billId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<AccessConstraint>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
  destination: VerificationRequestDestination;
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<InputObjectIdentifier>;
  requestParameters?: InputMaybe<Array<RequestParameter>>;
};


export type MutationSendMagicLinkEmailArgs = {
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitInvoiceCardPaymentArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
  riskData?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTokenRefreshArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnsubscribeArgs = {
  emailAddress: Scalars['String']['input'];
  notificationToken: Scalars['String']['input'];
};


export type MutationUpdateSignupArgs = {
  companyCurrency?: InputMaybe<Scalars['String']['input']>;
  companyLedger?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyURL?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  positionTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSignupFromOAuthArgs = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  service: OAuthService;
};

export enum OAuthService {
  Google = 'Google',
  LinkedIn = 'LinkedIn',
  QuickBooks = 'QuickBooks',
  Unknown = 'Unknown'
}

export enum ObjectKind {
  Bill = 'Bill',
  Category = 'Category',
  Comment = 'Comment',
  Connection = 'Connection',
  DataSource = 'DataSource',
  Department = 'Department',
  Discount = 'Discount',
  Invoice = 'Invoice',
  LedgerTransaction = 'LedgerTransaction',
  LegalEntity = 'LegalEntity',
  Location = 'Location',
  Party = 'Party',
  Portal = 'Portal',
  Product = 'Product',
  Reconciliation = 'Reconciliation',
  Report = 'Report',
  ReportPackage = 'ReportPackage',
  Schedule = 'Schedule',
  Thread = 'Thread',
  Transaction = 'Transaction',
  User = 'User',
  WorkItem = 'WorkItem'
}

export type Organization = {
  branding?: Maybe<OrganizationBranding>;
  displayId?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type OrganizationEmployment = {
  employeeId: Scalars['String']['output'];
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organization: Organization;
  role: Role;
};

export enum OrganizationKind {
  AccountingFirm = 'AccountingFirm',
  Developer = 'Developer',
  Operator = 'Operator',
  SandboxAccountingFirm = 'SandboxAccountingFirm',
  SandboxOperator = 'SandboxOperator',
  UnknownKind = 'UnknownKind'
}

export type OrganizationPreferences = {
  anonymizeEmployees: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type OrganizationTemplate = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PartyPreview = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PartyRole {
  EntityAssetRole = 'EntityAssetRole',
  EntityAssetSupplierRole = 'EntityAssetSupplierRole',
  EntityAssetVendorRole = 'EntityAssetVendorRole',
  EntityBanksRole = 'EntityBanksRole',
  EntityCreditCardsRole = 'EntityCreditCardsRole',
  EntityCustomerRole = 'EntityCustomerRole',
  EntityDebtorRole = 'EntityDebtorRole',
  EntityInvesteeRole = 'EntityInvesteeRole',
  EntityLenderRole = 'EntityLenderRole',
  EntityLiabilitiesRole = 'EntityLiabilitiesRole',
  EntityOtherExpensesRole = 'EntityOtherExpensesRole',
  EntityOtherIncomeRole = 'EntityOtherIncomeRole',
  EntityOtherLiabilitiesRole = 'EntityOtherLiabilitiesRole',
  EntityOwedVendorRole = 'EntityOwedVendorRole',
  EntityPrepaidVendorRole = 'EntityPrepaidVendorRole',
  EntityProcessorRole = 'EntityProcessorRole',
  EntityRevenuePartnerRole = 'EntityRevenuePartnerRole',
  EntityShareholderRole = 'EntityShareholderRole',
  EntitySupplierRole = 'EntitySupplierRole',
  EntityUnpaidCustomerRole = 'EntityUnpaidCustomerRole',
  EntityUnspecifiedRole = 'EntityUnspecifiedRole',
  EntityVendorRole = 'EntityVendorRole',
  FacilitatorRole = 'FacilitatorRole',
  InstitutionCreditRole = 'InstitutionCreditRole',
  InstitutionDebitRole = 'InstitutionDebitRole',
  OwnerRole = 'OwnerRole',
  PaymentProcessorRole = 'PaymentProcessorRole',
  UnknownRole = 'UnknownRole'
}

export type PasswordReset = {
  contact: Contact;
  isValid: Scalars['Boolean']['output'];
};

export type PayInvoiceSummary = {
  invoicePaymentDetails: InvoicePaymentDetails;
  status: InvoiceStatus;
};

export type PaymentInstrument = BankAccount | CreditCard;

export enum PaymentStatus {
  Blocked = 'Blocked',
  Canceled = 'Canceled',
  Created = 'Created',
  Deposited = 'Deposited',
  Held = 'Held',
  Mailed = 'Mailed',
  OnHold = 'OnHold',
  Paid = 'Paid',
  Pending = 'Pending',
  PendingApproval = 'PendingApproval',
  PendingIncreaseReview = 'PendingIncreaseReview',
  PendingMailing = 'PendingMailing',
  PendingSubmission = 'PendingSubmission',
  ProcessingReturn = 'ProcessingReturn',
  ProcessingSettlement = 'ProcessingSettlement',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  RequiresAttention = 'RequiresAttention',
  Returned = 'Returned',
  Settled = 'Settled',
  Stopped = 'Stopped',
  Submitted = 'Submitted',
  Unknown = 'Unknown'
}

export type Period = {
  endedAt: Scalars['DateTime']['output'];
  interval: Interval;
  name: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type PeriodInput = {
  endedAt: Scalars['DateTime']['input'];
  interval: Interval;
  name: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export enum Persona {
  AccountingLarge = 'AccountingLarge',
  AccountingMedium = 'AccountingMedium',
  AccountingSmall = 'AccountingSmall',
  Business = 'Business',
  BusinessAndSubsidiaries = 'BusinessAndSubsidiaries',
  InvestmentMedium = 'InvestmentMedium',
  InvestmentSmall = 'InvestmentSmall',
  MailingList = 'MailingList',
  UnknownPersona = 'UnknownPersona'
}

export type PlaidLinkToken = {
  token: Scalars['String']['output'];
};

export enum PlanIntent {
  AIAccountingPlan = 'AIAccountingPlan',
  AffiliatedAIAccountingPlan = 'AffiliatedAIAccountingPlan',
  AffiliatedFirmBooksPlan = 'AffiliatedFirmBooksPlan',
  AffiliatedLedgerOnlyPlan = 'AffiliatedLedgerOnlyPlan',
  AffiliatedLowVolumePlan = 'AffiliatedLowVolumePlan',
  AffiliatedReportsOnlyPlan = 'AffiliatedReportsOnlyPlan',
  DeveloperPlan = 'DeveloperPlan',
  FreePlan = 'FreePlan',
  GrowthPlan = 'GrowthPlan',
  PremiumPlan = 'PremiumPlan',
  ProspectFirmPlan = 'ProspectFirmPlan',
  UnknownPlan = 'UnknownPlan'
}

export enum ProposalType {
  AffiliateInviteManagedOperator = 'AffiliateInviteManagedOperator',
  AffiliationAssistClient = 'AffiliationAssistClient',
  AffiliationCreateClient = 'AffiliationCreateClient',
  AffiliationJoinClient = 'AffiliationJoinClient',
  CreateOrganization = 'CreateOrganization',
  EmploymentAssistOperator = 'EmploymentAssistOperator',
  EmploymentJoinOrg = 'EmploymentJoinOrg',
  EnterprisePackageInvite = 'EnterprisePackageInvite',
  OperatorAssistAffiliate = 'OperatorAssistAffiliate',
  UnknownProposalType = 'UnknownProposalType'
}

export enum ProviderType {
  CSVImport = 'CSVImport',
  Connect = 'Connect',
  Derived = 'Derived',
  Digits = 'Digits',
  DigitsInvoicing = 'DigitsInvoicing',
  DigitsLedgerInvoicing = 'DigitsLedgerInvoicing',
  DigitsLedgerPay = 'DigitsLedgerPay',
  DigitsPay = 'DigitsPay',
  DigitsPaymentsLedger = 'DigitsPaymentsLedger',
  DigitsSchedule = 'DigitsSchedule',
  Manual = 'Manual',
  Plaid = 'Plaid',
  QuickBooks = 'QuickBooks',
  UnknownProvider = 'UnknownProvider',
  Xero = 'Xero'
}

export type PublicInvoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type PublicSignup = {
  companyCurrency?: Maybe<Scalars['String']['output']>;
  companyLedger?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyURL?: Maybe<Scalars['String']['output']>;
  contact: Contact;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  persona: Persona;
  planIntent: PlanIntent;
  positionTitle?: Maybe<Scalars['String']['output']>;
  status: SignupStatus;
  verificationMethod: VerificationMethod;
};

export type QuantityValue = {
  quantity: Scalars['Long']['output'];
  quantityMultiplier: Scalars['Long']['output'];
};

export type Query = {
  /** Retrieves Adyen payment methods for paying an invoice with a card */
  getInvoicePaymentMethods: InvoicePaymentMethods;
  /**
   * Pay-based Bills aren't object-identifiable right now.
   * this is bill payment
   * @deprecated Use previewLedgerBill instead.
   */
  previewBillPayment: BillPaymentPreview;
  previewLedgerBill: LedgerBillPreview;
  previewShare: SharePreview;
  publicDocumentDownloadUrl: DocumentDownload;
  readInvitation: Invitation;
  readInvitationRecipient: UserContact;
  readPasswordReset: PasswordReset;
  readSSORequirement: SsoRequirement;
  readSignup: PublicSignup;
  viewInvoice: ViewInvoiceSummary;
  viewInvoiceFiles: Array<InvoiceFile>;
};


export type QueryGetInvoicePaymentMethodsArgs = {
  amount: InputMonetaryValue;
  invoiceId: Scalars['String']['input'];
  invoiceLegalEntityId: Scalars['String']['input'];
  payerLegalEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewBillPaymentArgs = {
  contactToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryPreviewLedgerBillArgs = {
  contactToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryPreviewShareArgs = {
  id: Scalars['String']['input'];
  intentId?: InputMaybe<Scalars['String']['input']>;
  kind: ObjectKind;
};


export type QueryPublicDocumentDownloadUrlArgs = {
  documentId: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
};


export type QueryReadInvitationArgs = {
  token: Scalars['String']['input'];
};


export type QueryReadInvitationRecipientArgs = {
  token: Scalars['String']['input'];
};


export type QueryReadPasswordResetArgs = {
  resetToken: Scalars['String']['input'];
};


export type QueryReadSsoRequirementArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QueryReadSignupArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewInvoiceFilesArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type RegistrationStatus = {
  alreadyRegistered?: Maybe<Scalars['Boolean']['output']>;
  session?: Maybe<Session>;
};

export enum ReportKind {
  APAging = 'APAging',
  ARAging = 'ARAging',
  BalanceSheet = 'BalanceSheet',
  CashFlow = 'CashFlow',
  ExpenseSummary = 'ExpenseSummary',
  ProfitAndLoss = 'ProfitAndLoss',
  Unknown = 'Unknown'
}

export type ReportPackagePreview = {
  author: EntityUser;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  interval: Interval;
  periodEndedAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  preparedBy?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type RequestParameter = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Role = {
  id: Scalars['String']['output'];
};

export type RoleIdentifier = {
  id: Scalars['String']['input'];
};

export type SsoRequirement = {
  requiresSSO: Scalars['Boolean']['output'];
  ssoIdentityProviderId?: Maybe<Scalars['String']['output']>;
  ssoIssuerURL?: Maybe<Scalars['String']['output']>;
  ssoOrganizationId?: Maybe<Scalars['String']['output']>;
};

export enum SandboxIndustry {
  Retail = 'Retail',
  Technology = 'Technology',
  UnknownIndustry = 'UnknownIndustry'
}

export enum SandboxType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  UnknownSandboxType = 'UnknownSandboxType'
}

export type SentInvoiceUsers = {
  invoice: Invoice;
  users?: Maybe<Array<User>>;
};

export type Session = {
  bearer: Scalars['String']['output'];
  employments?: Maybe<Array<SessionEmployment>>;
};

export type SessionAffiliation = {
  id: Scalars['String']['output'];
  kind?: Maybe<AffiliateType>;
  organization: SessionOrganization;
};

export enum SessionBillingMode {
  Billed = 'Billed',
  Included = 'Included',
  UnknownMode = 'UnknownMode'
}

export type SessionBillingPayer = {
  kind: SessionPayerKind;
  stripeSubscription: SessionSubscriptionStatus;
};

export type SessionEmployment = {
  affiliations: Array<SessionAffiliation>;
  id: Scalars['String']['output'];
  organization: SessionOrganization;
};

export type SessionLegalEntity = {
  affiliatedOrganizationIds: Array<Scalars['String']['output']>;
  aspects: Array<Scalars['String']['output']>;
  billing?: Maybe<SessionLegalEntityBilling>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: LegalEntityStatus;
  viewKeys: Array<SessionViewKey>;
};

export type SessionLegalEntityBilling = {
  payer: SessionBillingPayer;
  productCoverage?: Maybe<SessionProductCoverage>;
};

export type SessionOrganization = {
  aspects?: Maybe<Array<Scalars['String']['output']>>;
  /** Set only on the employing organization, not on affiliation organizations. */
  billing?: Maybe<SessionOrganizationBilling>;
  branding?: Maybe<SessionOrganizationBranding>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  legalEntities: Array<SessionLegalEntity>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type SessionOrganizationBilling = {
  /**
   * True when the billing database has a Stripe subscription ID recorded for the
   * organization, live or not (Canceled and Incomplete keep their IDs). Not an
   * attach gate by itself: an Incomplete subscription has an ID but rejects
   * attachments, so combine this bit with stripeSubscription.
   */
  hasStripeSubscription: Scalars['Boolean']['output'];
  /**
   * Observed status. UnknownStatus with hasStripeSubscription true means the state
   * is not observed yet.
   */
  stripeSubscription: SessionSubscriptionStatus;
};

export type SessionOrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum SessionPayerKind {
  AffiliatePaid = 'AffiliatePaid',
  SelfPaid = 'SelfPaid',
  UnknownKind = 'UnknownKind'
}

export type SessionProductCoverage = {
  legacy: Scalars['Boolean']['output'];
  mode: SessionBillingMode;
};

export enum SessionSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  UnknownStatus = 'UnknownStatus',
  Unpaid = 'Unpaid'
}

export type SessionViewKey = {
  legalEntityId: Scalars['String']['output'];
  mutationVersion?: Maybe<Scalars['String']['output']>;
  viewType?: Maybe<ViewType>;
  viewVersion?: Maybe<Scalars['String']['output']>;
};

export type ShareObject = CategoryPreview | PartyPreview | ReportPackagePreview | TransactionPreview;

export type SharePreview = {
  legalEntity: EntityLegalEntity;
  object: ShareObject;
  /** Invited user email. */
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type SignupAttribution = {
  fromCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum SignupStatus {
  Applied = 'Applied',
  Approved = 'Approved',
  Ignored = 'Ignored',
  InviteAccepted = 'InviteAccepted',
  Invited = 'Invited',
  PrimerSent = 'PrimerSent',
  Qualified = 'Qualified',
  Unknown = 'Unknown',
  Unqualified = 'Unqualified',
  Waitlisted = 'Waitlisted'
}

export enum TaxStatus {
  NonTaxable = 'NonTaxable',
  Taxable = 'Taxable',
  Undetermined = 'Undetermined',
  UnspecifiedTaxStatus = 'UnspecifiedTaxStatus'
}

export type TransactionPreview = {
  creditCategory?: Maybe<CategoryPreview>;
  debitCategory?: Maybe<CategoryPreview>;
  description?: Maybe<Scalars['String']['output']>;
  displayEntry: DisplayEntry;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<PartyPreview>;
  timestamp: Scalars['DateTime']['output'];
};

export type User = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employments?: Maybe<Array<OrganizationEmployment>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identities?: Maybe<Array<Identity>>;
  lastActivityAt: Scalars['DateTime']['output'];
  /** Timestamp when the user activated an MFA factor (e.g. TOTP). Null when no factor is enrolled. */
  mfaEnforcedAt?: Maybe<Scalars['DateTime']['output']>;
  passwordSet: Scalars['Boolean']['output'];
  primaryEmailAddress: Scalars['String']['output'];
};

export type UserContact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum VerificationMethod {
  AlreadyVerified = 'AlreadyVerified',
  Email = 'Email',
  Google = 'Google',
  UnknownVerificationMethod = 'UnknownVerificationMethod'
}

export enum VerificationRequestDestination {
  AIAccounting = 'AIAccounting',
  Bill = 'Bill',
  Developer = 'Developer',
  LedgerBill = 'LedgerBill',
  ProspectFirm = 'ProspectFirm',
  Share = 'Share',
  StartBusiness = 'StartBusiness',
  StartDeveloper = 'StartDeveloper',
  StartFirm = 'StartFirm',
  StartUnknown = 'StartUnknown',
  Unspecified = 'Unspecified'
}

export type ViewInvoiceSummary = {
  creditCardsEnabled: Scalars['Boolean']['output'];
  invoice: PublicInvoice;
  invoicePaymentDetails?: Maybe<InvoicePaymentDetails>;
  isPayable: Scalars['Boolean']['output'];
  useNewPaymentProvider: Scalars['Boolean']['output'];
};

export type ViewKey = {
  legalEntityId: Scalars['String']['input'];
  mutationVersion?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export enum ViewType {
  AIBookkeeper = 'AIBookkeeper',
  Ledger = 'Ledger',
  Unknown = 'Unknown'
}

export type CategoryPreviewFieldsFragment = Pick<CategoryPreview, 'name' | 'displayKey' | 'type'>;

export type InvoiceAddressFieldsFragment = (
  Pick<InvoicingAddress, 'id'>
  & { address: Pick<
      Address,
      | 'street'
      | 'streetAdditional'
      | 'city'
      | 'region'
      | 'postalCode'
      | 'countryCode'
      | 'lat'
      | 'long'
    > }
);

export type InvoiceFieldsFragment = (
  Pick<
    PublicInvoice,
    | 'id'
    | 'receivableInvoiceId'
    | 'legalEntityId'
    | 'status'
    | 'invoiceNumber'
    | 'invoiceDate'
    | 'dueDate'
    | 'taxPercent'
    | 'memo'
    | 'referenceNumber'
  >
  & {
    invoicingProfile?: Maybe<(
      Pick<
        InvoicingProfile,
        | 'id'
        | 'companyEmail'
        | 'companyName'
        | 'companyIcon'
        | 'payoutInstrumentID'
        | 'invoiceNumberFormatDefault'
        | 'invoiceNumberFormat'
      >
      & { companyAddress: (
        Pick<InvoicingAddress, 'id'>
        & { address: Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          > }
      ) }
    )>,
    customer?: Maybe<(
      Pick<
        Customer,
        | 'id'
        | 'name'
        | 'email'
        | 'icon'
        | 'providerType'
      >
      & { address?: Maybe<(
        Pick<CustomerAddress, 'id'>
        & { address?: Maybe<Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          >> }
      )> }
    )>,
    branding: Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'>,
    lineItems: Array<(
      Pick<
        InvoiceLineItem,
        | 'description'
        | 'id'
        | 'name'
        | 'taxable'
        | 'productId'
        | 'sku'
        | 'imageUrl'
        | 'position'
      >
      & {
        amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        discounts?: Maybe<Array<(
          Pick<InvoiceDiscount, 'invoiceDiscountId'>
          & {
            discount: (
              Pick<
                Discount,
                | 'discountId'
                | 'name'
                | 'variablePercentage'
                | 'providerType'
              >
              & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
            ),
            amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
        quantityValue?: Maybe<Pick<QuantityValue, 'quantity' | 'quantityMultiplier'>>,
      }
    )>,
    totalTax?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    subtotal?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    totalAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    discounts?: Maybe<Array<(
      Pick<InvoiceDiscount, 'invoiceDiscountId'>
      & {
        discount: (
          Pick<
            Discount,
            | 'discountId'
            | 'name'
            | 'variablePercentage'
            | 'providerType'
          >
          & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
        ),
        amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>>,
    files?: Maybe<Array<Pick<InvoiceFile, 'documentId' | 'fileType'>>>,
  }
);

export type InvoiceProfileFieldsFragment = (
  Pick<
    InvoicingProfile,
    | 'id'
    | 'companyEmail'
    | 'companyName'
    | 'companyIcon'
    | 'payoutInstrumentID'
    | 'invoiceNumberFormatDefault'
    | 'invoiceNumberFormat'
  >
  & { companyAddress: (
    Pick<InvoicingAddress, 'id'>
    & { address: Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      > }
  ) }
);

export type PartyPreviewFieldsFragment = Pick<PartyPreview, 'id' | 'name' | 'iconUrl'>;

export type PublicAddressFieldsFragment = Pick<
    Address,
    | 'street'
    | 'streetAdditional'
    | 'city'
    | 'region'
    | 'postalCode'
    | 'countryCode'
    | 'lat'
    | 'long'
  >;

export type PublicBankAccountFieldsFragment = (
  { __typename: 'BankAccount' }
  & Pick<
    BankAccount,
    | 'id'
    | 'institutionName'
    | 'name'
    | 'accountIdMask'
    | 'isDefault'
    | 'nickname'
    | 'isAutoPayout'
    | 'iconObjectName'
  >
);

export type PublicCreditCardFieldsFragment = (
  { __typename: 'CreditCard' }
  & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
);

export type PublicCustomerAddressFieldsFragment = (
  Pick<CustomerAddress, 'id'>
  & { address?: Maybe<Pick<
      Address,
      | 'street'
      | 'streetAdditional'
      | 'city'
      | 'region'
      | 'postalCode'
      | 'countryCode'
      | 'lat'
      | 'long'
    >> }
);

export type PublicCustomerFieldsFragment = (
  Pick<
    Customer,
    | 'id'
    | 'name'
    | 'email'
    | 'icon'
    | 'providerType'
  >
  & { address?: Maybe<(
    Pick<CustomerAddress, 'id'>
    & { address?: Maybe<Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      >> }
  )> }
);

export type PublicDiscountFieldsFragment = (
  Pick<
    Discount,
    | 'discountId'
    | 'name'
    | 'variablePercentage'
    | 'providerType'
  >
  & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
);

export type PublicEntityUserFieldsFragment = Pick<
    EntityUser,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'emailAddress'
    | 'avatarUrl'
  >;

export type PublicInvoiceBrandingFieldsFragment = Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'>;

export type PublicInvoiceDiscountFieldsFragment = (
  Pick<InvoiceDiscount, 'invoiceDiscountId'>
  & {
    discount: (
      Pick<
        Discount,
        | 'discountId'
        | 'name'
        | 'variablePercentage'
        | 'providerType'
      >
      & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
    ),
    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type PublicInvoiceFileFieldsFragment = Pick<InvoiceFile, 'documentId' | 'fileType'>;

export type PublicInvoiceLineItemFieldsFragment = (
  Pick<
    InvoiceLineItem,
    | 'description'
    | 'id'
    | 'name'
    | 'taxable'
    | 'productId'
    | 'sku'
    | 'imageUrl'
    | 'position'
  >
  & {
    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    discounts?: Maybe<Array<(
      Pick<InvoiceDiscount, 'invoiceDiscountId'>
      & {
        discount: (
          Pick<
            Discount,
            | 'discountId'
            | 'name'
            | 'variablePercentage'
            | 'providerType'
          >
          & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
        ),
        amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>>,
    quantityValue?: Maybe<Pick<QuantityValue, 'quantity' | 'quantityMultiplier'>>,
  }
);

export type PublicInvoicePaymentDetailsFieldsFragment = (
  Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
  & {
    paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    paymentInstrument:
      | (
        { __typename: 'BankAccount' }
        & Pick<
          BankAccount,
          | 'id'
          | 'institutionName'
          | 'name'
          | 'accountIdMask'
          | 'isDefault'
          | 'nickname'
          | 'isAutoPayout'
          | 'iconObjectName'
        >
      )
      | (
        { __typename: 'CreditCard' }
        & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
      )
    ,
  }
);

export type PublicLedgerBillPreviewFieldsFragment = (
  Pick<
    LedgerBillPreview,
    | 'billId'
    | 'externalId'
    | 'payerCompanyName'
    | 'payerEmailAddress'
  >
  & {
    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    vendor: Pick<LedgerBillPreviewVendor, 'name' | 'email'>,
    invoiceDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    image?: Maybe<Pick<BillPaymentPreviewSegment, 'collectionId' | 'fileId' | 'token'>>,
  }
);

export type PublicMonetaryValueFieldsFragment = Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>;

export type PublicPayInvoiceSummaryFieldsFragment = (
  Pick<PayInvoiceSummary, 'status'>
  & { invoicePaymentDetails: (
    Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
    & {
      paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      paymentInstrument:
        | (
          { __typename: 'BankAccount' }
          & Pick<
            BankAccount,
            | 'id'
            | 'institutionName'
            | 'name'
            | 'accountIdMask'
            | 'isDefault'
            | 'nickname'
            | 'isAutoPayout'
            | 'iconObjectName'
          >
        )
        | (
          { __typename: 'CreditCard' }
          & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
        )
      ,
    }
  ) }
);

export type PublicSignupFieldsFragment = (
  Pick<
    PublicSignup,
    | 'id'
    | 'positionTitle'
    | 'companyName'
    | 'companyURL'
    | 'companyLedger'
    | 'companyCurrency'
    | 'industry'
    | 'status'
    | 'persona'
    | 'verificationMethod'
    | 'planIntent'
  >
  & { contact: Pick<
      Contact,
      | 'avatarUrl'
      | 'familyName'
      | 'givenName'
      | 'emailAddress'
    > }
);

export type SessionFieldsFragment = (
  Pick<Session, 'bearer'>
  & { employments?: Maybe<Array<(
    Pick<SessionEmployment, 'id'>
    & {
      organization: (
        Pick<
          SessionOrganization,
          | 'id'
          | 'name'
          | 'kind'
          | 'slug'
          | 'iconUrl'
          | 'websiteUrl'
          | 'aspects'
        >
        & {
          branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
          billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
          legalEntities: Array<(
            Pick<
              SessionLegalEntity,
              | 'id'
              | 'name'
              | 'slug'
              | 'iconUrl'
              | 'status'
              | 'aspects'
              | 'affiliatedOrganizationIds'
            >
            & {
              viewKeys: Array<Pick<
                  SessionViewKey,
                  | 'legalEntityId'
                  | 'viewVersion'
                  | 'mutationVersion'
                  | 'viewType'
                >>,
              billing?: Maybe<{
                  payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                  productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                }>,
            }
          )>,
        }
      ),
      affiliations: Array<(
        Pick<SessionAffiliation, 'id' | 'kind'>
        & { organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ) }
      )>,
    }
  )>> }
);

export type EmploymentFieldsFragment = (
  Pick<SessionEmployment, 'id'>
  & {
    organization: (
      Pick<
        SessionOrganization,
        | 'id'
        | 'name'
        | 'kind'
        | 'slug'
        | 'iconUrl'
        | 'websiteUrl'
        | 'aspects'
      >
      & {
        branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
        billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
        legalEntities: Array<(
          Pick<
            SessionLegalEntity,
            | 'id'
            | 'name'
            | 'slug'
            | 'iconUrl'
            | 'status'
            | 'aspects'
            | 'affiliatedOrganizationIds'
          >
          & {
            viewKeys: Array<Pick<
                SessionViewKey,
                | 'legalEntityId'
                | 'viewVersion'
                | 'mutationVersion'
                | 'viewType'
              >>,
            billing?: Maybe<{
                payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
              }>,
          }
        )>,
      }
    ),
    affiliations: Array<(
      Pick<SessionAffiliation, 'id' | 'kind'>
      & { organization: (
        Pick<
          SessionOrganization,
          | 'id'
          | 'name'
          | 'kind'
          | 'slug'
          | 'iconUrl'
          | 'websiteUrl'
          | 'aspects'
        >
        & {
          branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
          billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
          legalEntities: Array<(
            Pick<
              SessionLegalEntity,
              | 'id'
              | 'name'
              | 'slug'
              | 'iconUrl'
              | 'status'
              | 'aspects'
              | 'affiliatedOrganizationIds'
            >
            & {
              viewKeys: Array<Pick<
                  SessionViewKey,
                  | 'legalEntityId'
                  | 'viewVersion'
                  | 'mutationVersion'
                  | 'viewType'
                >>,
              billing?: Maybe<{
                  payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                  productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                }>,
            }
          )>,
        }
      ) }
    )>,
  }
);

export type SessionOrganizationFieldsFragment = (
  Pick<
    SessionOrganization,
    | 'id'
    | 'name'
    | 'kind'
    | 'slug'
    | 'iconUrl'
    | 'websiteUrl'
    | 'aspects'
  >
  & {
    branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
    billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
    legalEntities: Array<(
      Pick<
        SessionLegalEntity,
        | 'id'
        | 'name'
        | 'slug'
        | 'iconUrl'
        | 'status'
        | 'aspects'
        | 'affiliatedOrganizationIds'
      >
      & {
        viewKeys: Array<Pick<
            SessionViewKey,
            | 'legalEntityId'
            | 'viewVersion'
            | 'mutationVersion'
            | 'viewType'
          >>,
        billing?: Maybe<{
            payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
            productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
          }>,
      }
    )>,
  }
);

export type SessionLegalEntityFieldsFragment = (
  Pick<
    SessionLegalEntity,
    | 'id'
    | 'name'
    | 'slug'
    | 'iconUrl'
    | 'status'
    | 'aspects'
    | 'affiliatedOrganizationIds'
  >
  & {
    viewKeys: Array<Pick<
        SessionViewKey,
        | 'legalEntityId'
        | 'viewVersion'
        | 'mutationVersion'
        | 'viewType'
      >>,
    billing?: Maybe<{
        payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
        productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
      }>,
  }
);

export type SessionLegalEntityBillingFieldsFragment = {
    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
  };

export type SessionAffiliationFieldsFragment = (
  Pick<SessionAffiliation, 'id' | 'kind'>
  & { organization: (
    Pick<
      SessionOrganization,
      | 'id'
      | 'name'
      | 'kind'
      | 'slug'
      | 'iconUrl'
      | 'websiteUrl'
      | 'aspects'
    >
    & {
      branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
      billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
      legalEntities: Array<(
        Pick<
          SessionLegalEntity,
          | 'id'
          | 'name'
          | 'slug'
          | 'iconUrl'
          | 'status'
          | 'aspects'
          | 'affiliatedOrganizationIds'
        >
        & {
          viewKeys: Array<Pick<
              SessionViewKey,
              | 'legalEntityId'
              | 'viewVersion'
              | 'mutationVersion'
              | 'viewType'
            >>,
          billing?: Maybe<{
              payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
              productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
            }>,
        }
      )>,
    }
  ) }
);

export type SessionViewKeyFieldsFragment = Pick<
    SessionViewKey,
    | 'legalEntityId'
    | 'viewVersion'
    | 'mutationVersion'
    | 'viewType'
  >;

export type SessionOrganizationBrandingFieldsFragment = Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>;

export type TransactionPreviewFieldsFragment = (
  Pick<TransactionPreview, 'timestamp' | 'description' | 'displayEntry'>
  & { transactionName: TransactionPreview['name'] }
  & {
    party?: Maybe<Pick<PartyPreview, 'id' | 'name' | 'iconUrl'>>,
    creditCategory?: Maybe<Pick<CategoryPreview, 'name' | 'displayKey' | 'type'>>,
    debitCategory?: Maybe<Pick<CategoryPreview, 'name' | 'displayKey' | 'type'>>,
  }
);

export type ViewInvoiceSummaryFieldsFragment = (
  Pick<ViewInvoiceSummary, 'isPayable' | 'useNewPaymentProvider' | 'creditCardsEnabled'>
  & {
    invoice: (
      Pick<
        PublicInvoice,
        | 'id'
        | 'receivableInvoiceId'
        | 'legalEntityId'
        | 'status'
        | 'invoiceNumber'
        | 'invoiceDate'
        | 'dueDate'
        | 'taxPercent'
        | 'memo'
        | 'referenceNumber'
      >
      & {
        invoicingProfile?: Maybe<(
          Pick<
            InvoicingProfile,
            | 'id'
            | 'companyEmail'
            | 'companyName'
            | 'companyIcon'
            | 'payoutInstrumentID'
            | 'invoiceNumberFormatDefault'
            | 'invoiceNumberFormat'
          >
          & { companyAddress: (
            Pick<InvoicingAddress, 'id'>
            & { address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              > }
          ) }
        )>,
        customer?: Maybe<(
          Pick<
            Customer,
            | 'id'
            | 'name'
            | 'email'
            | 'icon'
            | 'providerType'
          >
          & { address?: Maybe<(
            Pick<CustomerAddress, 'id'>
            & { address?: Maybe<Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >> }
          )> }
        )>,
        branding: Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'>,
        lineItems: Array<(
          Pick<
            InvoiceLineItem,
            | 'description'
            | 'id'
            | 'name'
            | 'taxable'
            | 'productId'
            | 'sku'
            | 'imageUrl'
            | 'position'
          >
          & {
            amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            discounts?: Maybe<Array<(
              Pick<InvoiceDiscount, 'invoiceDiscountId'>
              & {
                discount: (
                  Pick<
                    Discount,
                    | 'discountId'
                    | 'name'
                    | 'variablePercentage'
                    | 'providerType'
                  >
                  & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                ),
                amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>>,
            quantityValue?: Maybe<Pick<QuantityValue, 'quantity' | 'quantityMultiplier'>>,
          }
        )>,
        totalTax?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        subtotal?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        totalAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        discounts?: Maybe<Array<(
          Pick<InvoiceDiscount, 'invoiceDiscountId'>
          & {
            discount: (
              Pick<
                Discount,
                | 'discountId'
                | 'name'
                | 'variablePercentage'
                | 'providerType'
              >
              & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
            ),
            amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
        files?: Maybe<Array<Pick<InvoiceFile, 'documentId' | 'fileType'>>>,
      }
    ),
    invoicePaymentDetails?: Maybe<(
      Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
      & {
        paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        paymentInstrument:
          | (
            { __typename: 'BankAccount' }
            & Pick<
              BankAccount,
              | 'id'
              | 'institutionName'
              | 'name'
              | 'accountIdMask'
              | 'isDefault'
              | 'nickname'
              | 'isAutoPayout'
              | 'iconObjectName'
            >
          )
          | (
            { __typename: 'CreditCard' }
            & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
          )
        ,
      }
    )>,
  }
);

export type AddSignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<Persona>;
  planIntent: PlanIntent;
  attribution?: InputMaybe<SignupAttribution>;
}>;


export type AddSignupMutation = { signup: (
    Pick<
      PublicSignup,
      | 'id'
      | 'positionTitle'
      | 'companyName'
      | 'companyURL'
      | 'companyLedger'
      | 'companyCurrency'
      | 'industry'
      | 'status'
      | 'persona'
      | 'verificationMethod'
      | 'planIntent'
    >
    & { contact: Pick<
        Contact,
        | 'avatarUrl'
        | 'familyName'
        | 'givenName'
        | 'emailAddress'
      > }
  ) };

export type BeginLoginMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type BeginLoginMutation = { beginLogin: Pick<BeginLogin, 'requiresSSO' | 'ssoIssuerURL'> };

export type CompleteMfaChallengeMutationVariables = Exact<{
  challengeToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  method: MfaMethod;
}>;


export type CompleteMfaChallengeMutation = { completeMfaChallenge: (
    Pick<Session, 'bearer'>
    & { employments?: Maybe<Array<(
      Pick<SessionEmployment, 'id'>
      & {
        organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ),
        affiliations: Array<(
          Pick<SessionAffiliation, 'id' | 'kind'>
          & { organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ) }
        )>,
      }
    )>> }
  ) };

export type CreatePasswordResetMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  object?: InputMaybe<InputObjectIdentifier>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  ledgerBillId?: InputMaybe<Scalars['String']['input']>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePasswordResetMutation = Pick<Mutation, 'createPasswordReset'>;

export type CreatePaymentPlaidLinkTokenMutationVariables = Exact<{
  plaidClientUserId: Scalars['String']['input'];
}>;


export type CreatePaymentPlaidLinkTokenMutation = { createPaymentPlaidLinkToken: Pick<PlaidLinkToken, 'token'> };

export type CreatePlaidGuestBankAccountInstrumentMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  useNewPaymentProvider: Scalars['Boolean']['input'];
}>;


export type CreatePlaidGuestBankAccountInstrumentMutation = { createPlaidGuestBankAccountInstrument:
    | (
      { __typename: 'BankAccount' }
      & Pick<
        BankAccount,
        | 'id'
        | 'institutionName'
        | 'name'
        | 'accountIdMask'
        | 'isDefault'
        | 'nickname'
        | 'isAutoPayout'
        | 'iconObjectName'
      >
    )
    | { __typename: 'CreditCard' }
   };

export type HandleInvoiceCardPaymentActionMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
  billingAddress?: InputMaybe<CardBillingAddressInput>;
}>;


export type HandleInvoiceCardPaymentActionMutation = { handleInvoiceCardPaymentAction: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'errorMessage'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type LedgerHandleInvoiceCardPaymentActionMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  expectedAmount: InputMonetaryValue;
}>;


export type LedgerHandleInvoiceCardPaymentActionMutation = { ledgerHandleInvoiceCardPaymentAction: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'errorMessage'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type LedgerPayInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
  expectedAmount: InputMonetaryValue;
}>;


export type LedgerPayInvoiceMutation = { ledgerPayInvoice: (
    Pick<PayInvoiceSummary, 'status'>
    & { invoicePaymentDetails: (
      Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
      & {
        paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        paymentInstrument:
          | (
            { __typename: 'BankAccount' }
            & Pick<
              BankAccount,
              | 'id'
              | 'institutionName'
              | 'name'
              | 'accountIdMask'
              | 'isDefault'
              | 'nickname'
              | 'isAutoPayout'
              | 'iconObjectName'
            >
          )
          | (
            { __typename: 'CreditCard' }
            & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
          )
        ,
      }
    ) }
  ) };

export type LedgerSubmitInvoiceCardPaymentMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  riskData?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  expectedAmount: InputMonetaryValue;
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerSubmitInvoiceCardPaymentMutation = { ledgerSubmitInvoiceCardPayment: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'actionData'
      | 'errorMessage'
      | 'refusalReasonCode'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type LogInAppInstanceMutationVariables = Exact<{
  id: Scalars['String']['input'];
  challenge: AppInstanceChallenge;
  profile: AppInstanceProfile;
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInAppInstanceMutation = { logInAppInstance: (
    Pick<Session, 'bearer'>
    & { employments?: Maybe<Array<(
      Pick<SessionEmployment, 'id'>
      & {
        organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ),
        affiliations: Array<(
          Pick<SessionAffiliation, 'id' | 'kind'>
          & { organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ) }
        )>,
      }
    )>> }
  ) };

export type LogInEmailMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInEmailMutation = { logInEmail: (
    Pick<Session, 'bearer'>
    & { employments?: Maybe<Array<(
      Pick<SessionEmployment, 'id'>
      & {
        organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ),
        affiliations: Array<(
          Pick<SessionAffiliation, 'id' | 'kind'>
          & { organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ) }
        )>,
      }
    )>> }
  ) };

export type LogInMagicLinkMutationVariables = Exact<{
  token: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInMagicLinkMutation = { logInMagicLink: (
    Pick<Session, 'bearer'>
    & { employments?: Maybe<Array<(
      Pick<SessionEmployment, 'id'>
      & {
        organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ),
        affiliations: Array<(
          Pick<SessionAffiliation, 'id' | 'kind'>
          & { organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ) }
        )>,
      }
    )>> }
  ) };

export type LogInOAuthMutationVariables = Exact<{
  service: OAuthService;
  code: Scalars['String']['input'];
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInOAuthMutation = { logInOAuth: (
    Pick<Session, 'bearer'>
    & { employments?: Maybe<Array<(
      Pick<SessionEmployment, 'id'>
      & {
        organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ),
        affiliations: Array<(
          Pick<SessionAffiliation, 'id' | 'kind'>
          & { organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ) }
        )>,
      }
    )>> }
  ) };

export type LogInSupportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LogInSupportMutation = { logInSupport: Pick<Session, 'bearer'> };

export type LogOutSupportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LogOutSupportMutation = { logOutSupport: Pick<Session, 'bearer'> };

export type PayInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  receivableInvoiceId?: InputMaybe<Scalars['String']['input']>;
  paymentInstrumentId: Scalars['String']['input'];
}>;


export type PayInvoiceMutation = { payInvoice: (
    Pick<PayInvoiceSummary, 'status'>
    & { invoicePaymentDetails: (
      Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
      & {
        paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        paymentInstrument:
          | (
            { __typename: 'BankAccount' }
            & Pick<
              BankAccount,
              | 'id'
              | 'institutionName'
              | 'name'
              | 'accountIdMask'
              | 'isDefault'
              | 'nickname'
              | 'isAutoPayout'
              | 'iconObjectName'
            >
          )
          | (
            { __typename: 'CreditCard' }
            & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
          )
        ,
      }
    ) }
  ) };

export type ProvisionVerificationTokenMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  object: InputObjectIdentifier;
  intentId: Scalars['String']['input'];
}>;


export type ProvisionVerificationTokenMutation = { provisionVerificationToken: Pick<ConfirmationToken, 'token'> };

export type RegisterInviteOAuthMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  code: Scalars['String']['input'];
  service: OAuthService;
}>;


export type RegisterInviteOAuthMutation = { registerInviteOAuth: Pick<Session, 'bearer'> };

export type RegisterInvitePasswordlessMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterInvitePasswordlessMutation = { registerInvitePasswordless: Pick<Session, 'bearer'> };

export type RegisterUserEmailTokenMutationVariables = Exact<{
  confirmToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserEmailTokenMutation = { registerUserEmailToken: (
    Pick<RegistrationStatus, 'alreadyRegistered'>
    & { session?: Maybe<(
      Pick<Session, 'bearer'>
      & { employments?: Maybe<Array<(
        Pick<SessionEmployment, 'id'>
        & {
          organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ),
          affiliations: Array<(
            Pick<SessionAffiliation, 'id' | 'kind'>
            & { organization: (
              Pick<
                SessionOrganization,
                | 'id'
                | 'name'
                | 'kind'
                | 'slug'
                | 'iconUrl'
                | 'websiteUrl'
                | 'aspects'
              >
              & {
                branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
                billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
                legalEntities: Array<(
                  Pick<
                    SessionLegalEntity,
                    | 'id'
                    | 'name'
                    | 'slug'
                    | 'iconUrl'
                    | 'status'
                    | 'aspects'
                    | 'affiliatedOrganizationIds'
                  >
                  & {
                    viewKeys: Array<Pick<
                        SessionViewKey,
                        | 'legalEntityId'
                        | 'viewVersion'
                        | 'mutationVersion'
                        | 'viewType'
                      >>,
                    billing?: Maybe<{
                        payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                        productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                      }>,
                  }
                )>,
              }
            ) }
          )>,
        }
      )>> }
    )> }
  ) };

export type RegisterUserOAuthMutationVariables = Exact<{
  service: OAuthService;
  code: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserOAuthMutation = { registerUserOAuth: Pick<Session, 'bearer'> };

export type ResetPasswordMutationVariables = Exact<{
  resetToken: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: (
    Pick<Session, 'bearer'>
    & { employments?: Maybe<Array<(
      Pick<SessionEmployment, 'id'>
      & {
        organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ),
        affiliations: Array<(
          Pick<SessionAffiliation, 'id' | 'kind'>
          & { organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ) }
        )>,
      }
    )>> }
  ) };

export type SendAcceptedInvitationMagicLinkMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendAcceptedInvitationMagicLinkMutation = Pick<Mutation, 'sendAcceptedInvitationMagicLink'>;

export type SendEmailVerificationMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  destination: VerificationRequestDestination;
  object?: InputMaybe<InputObjectIdentifier>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<AccessConstraint>;
  billId?: InputMaybe<Scalars['String']['input']>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
  requestParameters?: InputMaybe<Array<RequestParameter> | RequestParameter>;
}>;


export type SendEmailVerificationMutation = Pick<Mutation, 'sendEmailVerification'>;

export type SendMagicLinkEmailMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendMagicLinkEmailMutation = Pick<Mutation, 'sendMagicLinkEmail'>;

export type SubmitInvoiceCardPaymentMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  riskData?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitInvoiceCardPaymentMutation = { submitInvoiceCardPayment: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'actionData'
      | 'errorMessage'
      | 'refusalReasonCode'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type TokenRefreshMutationVariables = Exact<{
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TokenRefreshMutation = { tokenRefresh: (
    Pick<Session, 'bearer'>
    & { employments?: Maybe<Array<(
      Pick<SessionEmployment, 'id'>
      & {
        organization: (
          Pick<
            SessionOrganization,
            | 'id'
            | 'name'
            | 'kind'
            | 'slug'
            | 'iconUrl'
            | 'websiteUrl'
            | 'aspects'
          >
          & {
            branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
            billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
            legalEntities: Array<(
              Pick<
                SessionLegalEntity,
                | 'id'
                | 'name'
                | 'slug'
                | 'iconUrl'
                | 'status'
                | 'aspects'
                | 'affiliatedOrganizationIds'
              >
              & {
                viewKeys: Array<Pick<
                    SessionViewKey,
                    | 'legalEntityId'
                    | 'viewVersion'
                    | 'mutationVersion'
                    | 'viewType'
                  >>,
                billing?: Maybe<{
                    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                  }>,
              }
            )>,
          }
        ),
        affiliations: Array<(
          Pick<SessionAffiliation, 'id' | 'kind'>
          & { organization: (
            Pick<
              SessionOrganization,
              | 'id'
              | 'name'
              | 'kind'
              | 'slug'
              | 'iconUrl'
              | 'websiteUrl'
              | 'aspects'
            >
            & {
              branding?: Maybe<Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>>,
              billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
              legalEntities: Array<(
                Pick<
                  SessionLegalEntity,
                  | 'id'
                  | 'name'
                  | 'slug'
                  | 'iconUrl'
                  | 'status'
                  | 'aspects'
                  | 'affiliatedOrganizationIds'
                >
                & {
                  viewKeys: Array<Pick<
                      SessionViewKey,
                      | 'legalEntityId'
                      | 'viewVersion'
                      | 'mutationVersion'
                      | 'viewType'
                    >>,
                  billing?: Maybe<{
                      payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
                      productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
                    }>,
                }
              )>,
            }
          ) }
        )>,
      }
    )>> }
  ) };

export type UnsubscribeMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  notificationToken: Scalars['String']['input'];
}>;


export type UnsubscribeMutation = Pick<Mutation, 'unsubscribe'>;

export type GetInvoicePaymentMethodsQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  amount: InputMonetaryValue;
  payerLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  invoiceLegalEntityId: Scalars['String']['input'];
}>;


export type GetInvoicePaymentMethodsQuery = { getInvoicePaymentMethods: Pick<InvoicePaymentMethods, 'clientKey' | 'environment' | 'paymentMethodsResponse'> };

export type LedgerBillIdForBillPaymentQueryVariables = Exact<{
  billPaymentId: Scalars['String']['input'];
  contactToken: Scalars['String']['input'];
}>;


export type LedgerBillIdForBillPaymentQuery = { previewBillPayment: Pick<BillPaymentPreview, 'billId' | 'id'> };

export type PreviewLedgerBillQueryVariables = Exact<{
  id: Scalars['String']['input'];
  contactToken: Scalars['String']['input'];
}>;


export type PreviewLedgerBillQuery = { previewLedgerBill: (
    Pick<
      LedgerBillPreview,
      | 'billId'
      | 'externalId'
      | 'payerCompanyName'
      | 'payerEmailAddress'
    >
    & {
      amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      vendor: Pick<LedgerBillPreviewVendor, 'name' | 'email'>,
      invoiceDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
      dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
      image?: Maybe<Pick<BillPaymentPreviewSegment, 'collectionId' | 'fileId' | 'token'>>,
    }
  ) };

export type PreviewShareQueryVariables = Exact<{
  kind: ObjectKind;
  id: Scalars['String']['input'];
  intentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PreviewShareQuery = { previewShare: (
    Pick<SharePreview, 'userEmail'>
    & {
      legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
      object:
        | (
          { __typename: 'CategoryPreview' }
          & Pick<CategoryPreview, 'name' | 'displayKey' | 'type'>
        )
        | (
          { __typename: 'PartyPreview' }
          & Pick<PartyPreview, 'id' | 'name' | 'iconUrl'>
        )
        | (
          { __typename: 'ReportPackagePreview' }
          & Pick<
            ReportPackagePreview,
            | 'createdAt'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'interval'
            | 'title'
            | 'coverUrl'
            | 'preparedBy'
          >
          & { author: Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            > }
        )
        | (
          { __typename: 'TransactionPreview' }
          & Pick<TransactionPreview, 'timestamp' | 'description' | 'displayEntry'>
          & { transactionName: TransactionPreview['name'] }
          & {
            party?: Maybe<Pick<PartyPreview, 'id' | 'name' | 'iconUrl'>>,
            creditCategory?: Maybe<Pick<CategoryPreview, 'name' | 'displayKey' | 'type'>>,
            debitCategory?: Maybe<Pick<CategoryPreview, 'name' | 'displayKey' | 'type'>>,
          }
        )
      ,
    }
  ) };

export type PublicDocumentDownloadUrlQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
}>;


export type PublicDocumentDownloadUrlQuery = { publicDocumentDownloadUrl: Pick<DocumentDownload, 'url'> };

export type ReadInvitationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ReadInvitationQuery = {
    readInvitation: (
      Pick<
        Invitation,
        | 'id'
        | 'service'
        | 'invitationType'
        | 'organizationTemplateId'
      >
      & {
        recipient: Pick<Contact, 'givenName' | 'familyName' | 'emailAddress'>,
        sender?: Maybe<Pick<Contact, 'givenName' | 'avatarUrl' | 'emailAddress'>>,
        organization?: Maybe<Pick<Organization, 'id' | 'slug' | 'name'>>,
        legalEntityRoles?: Maybe<Array<Pick<EmployeeLegalEntityRole, 'legalEntityId'>>>,
      }
    ),
    readInvitationRecipient: Pick<
        UserContact,
        | 'userId'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
  };

export type ReadInvitationRecipientQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ReadInvitationRecipientQuery = { readInvitationRecipient: Pick<
      UserContact,
      | 'userId'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    > };

export type ReadPasswordResetQueryVariables = Exact<{
  resetToken: Scalars['String']['input'];
}>;


export type ReadPasswordResetQuery = { readPasswordReset: (
    Pick<PasswordReset, 'isValid'>
    & { contact: Pick<
        Contact,
        | 'familyName'
        | 'givenName'
        | 'emailAddress'
        | 'avatarUrl'
      > }
  ) };

export type ReadSsoRequirementQueryVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type ReadSsoRequirementQuery = { readSSORequirement: Pick<SsoRequirement, 'requiresSSO' | 'ssoIssuerURL'> };

export type ReadSignupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadSignupQuery = { readSignup: (
    Pick<
      PublicSignup,
      | 'id'
      | 'positionTitle'
      | 'companyName'
      | 'companyURL'
      | 'companyLedger'
      | 'companyCurrency'
      | 'industry'
      | 'status'
      | 'persona'
      | 'verificationMethod'
      | 'planIntent'
    >
    & { contact: Pick<
        Contact,
        | 'avatarUrl'
        | 'familyName'
        | 'givenName'
        | 'emailAddress'
      > }
  ) };

export type ViewInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewInvoiceQuery = { viewInvoice: (
    Pick<ViewInvoiceSummary, 'isPayable' | 'useNewPaymentProvider' | 'creditCardsEnabled'>
    & {
      invoice: (
        Pick<
          PublicInvoice,
          | 'id'
          | 'receivableInvoiceId'
          | 'legalEntityId'
          | 'status'
          | 'invoiceNumber'
          | 'invoiceDate'
          | 'dueDate'
          | 'taxPercent'
          | 'memo'
          | 'referenceNumber'
        >
        & {
          invoicingProfile?: Maybe<(
            Pick<
              InvoicingProfile,
              | 'id'
              | 'companyEmail'
              | 'companyName'
              | 'companyIcon'
              | 'payoutInstrumentID'
              | 'invoiceNumberFormatDefault'
              | 'invoiceNumberFormat'
            >
            & { companyAddress: (
              Pick<InvoicingAddress, 'id'>
              & { address: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                > }
            ) }
          )>,
          customer?: Maybe<(
            Pick<
              Customer,
              | 'id'
              | 'name'
              | 'email'
              | 'icon'
              | 'providerType'
            >
            & { address?: Maybe<(
              Pick<CustomerAddress, 'id'>
              & { address?: Maybe<Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                >> }
            )> }
          )>,
          branding: Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'>,
          lineItems: Array<(
            Pick<
              InvoiceLineItem,
              | 'description'
              | 'id'
              | 'name'
              | 'taxable'
              | 'productId'
              | 'sku'
              | 'imageUrl'
              | 'position'
            >
            & {
              amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              discounts?: Maybe<Array<(
                Pick<InvoiceDiscount, 'invoiceDiscountId'>
                & {
                  discount: (
                    Pick<
                      Discount,
                      | 'discountId'
                      | 'name'
                      | 'variablePercentage'
                      | 'providerType'
                    >
                    & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                  ),
                  amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>>,
              quantityValue?: Maybe<Pick<QuantityValue, 'quantity' | 'quantityMultiplier'>>,
            }
          )>,
          totalTax?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          subtotal?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          totalAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          discounts?: Maybe<Array<(
            Pick<InvoiceDiscount, 'invoiceDiscountId'>
            & {
              discount: (
                Pick<
                  Discount,
                  | 'discountId'
                  | 'name'
                  | 'variablePercentage'
                  | 'providerType'
                >
                & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              ),
              amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              discountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
          files?: Maybe<Array<Pick<InvoiceFile, 'documentId' | 'fileType'>>>,
        }
      ),
      invoicePaymentDetails?: Maybe<(
        Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
        & {
          paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          paymentInstrument:
            | (
              { __typename: 'BankAccount' }
              & Pick<
                BankAccount,
                | 'id'
                | 'institutionName'
                | 'name'
                | 'accountIdMask'
                | 'isDefault'
                | 'nickname'
                | 'isAutoPayout'
                | 'iconObjectName'
              >
            )
            | (
              { __typename: 'CreditCard' }
              & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
            )
          ,
        }
      )>,
    }
  ) };

export type ViewInvoiceFilesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type ViewInvoiceFilesQuery = { viewInvoiceFiles: Array<Pick<InvoiceFile, 'documentId' | 'fileType'>> };

export type LogOutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogOutMutation = Pick<Mutation, 'logOut'>;

export const PublicEntityUserFieldsFragmentDoc = gql`
    fragment PublicEntityUserFields on EntityUser {
  id
  givenName
  familyName
  emailAddress
  avatarUrl
}
    `;
export const PublicMonetaryValueFieldsFragmentDoc = gql`
    fragment PublicMonetaryValueFields on MonetaryValue {
  iso4217CurrencyCode
  currencyMultiplier
  amount
}
    `;
export const PublicLedgerBillPreviewFieldsFragmentDoc = gql`
    fragment PublicLedgerBillPreviewFields on LedgerBillPreview {
  billId
  externalId
  payerCompanyName
  payerEmailAddress
  amount {
    ...PublicMonetaryValueFields
  }
  vendor {
    name
    email
  }
  invoiceDate {
    year
    month
    day
  }
  dueDate {
    year
    month
    day
  }
  image {
    collectionId
    fileId
    token
  }
}
    ${PublicMonetaryValueFieldsFragmentDoc}`;
export const PublicBankAccountFieldsFragmentDoc = gql`
    fragment PublicBankAccountFields on BankAccount {
  __typename
  id
  institutionName
  name
  accountIdMask
  isDefault
  nickname
  isAutoPayout
  iconObjectName
}
    `;
export const PublicCreditCardFieldsFragmentDoc = gql`
    fragment PublicCreditCardFields on CreditCard {
  __typename
  id
  cardLastFour
  cardBrand
}
    `;
export const PublicInvoicePaymentDetailsFieldsFragmentDoc = gql`
    fragment PublicInvoicePaymentDetailsFields on InvoicePaymentDetails {
  paymentConfirmationId
  paymentDate
  paymentAmount {
    ...PublicMonetaryValueFields
  }
  paymentInstrument {
    ...PublicBankAccountFields
    ...PublicCreditCardFields
  }
}
    ${PublicMonetaryValueFieldsFragmentDoc}
${PublicBankAccountFieldsFragmentDoc}
${PublicCreditCardFieldsFragmentDoc}`;
export const PublicPayInvoiceSummaryFieldsFragmentDoc = gql`
    fragment PublicPayInvoiceSummaryFields on PayInvoiceSummary {
  invoicePaymentDetails {
    ...PublicInvoicePaymentDetailsFields
  }
  status
}
    ${PublicInvoicePaymentDetailsFieldsFragmentDoc}`;
export const PublicSignupFieldsFragmentDoc = gql`
    fragment PublicSignupFields on PublicSignup {
  id
  contact {
    avatarUrl
    familyName
    givenName
    emailAddress
  }
  positionTitle
  companyName
  companyURL
  companyLedger
  companyCurrency
  industry
  status
  persona
  verificationMethod
  planIntent
}
    `;
export const SessionOrganizationBrandingFieldsFragmentDoc = gql`
    fragment SessionOrganizationBrandingFields on SessionOrganizationBranding {
  id
  headerColor
  headerTextColor
}
    `;
export const SessionViewKeyFieldsFragmentDoc = gql`
    fragment SessionViewKeyFields on SessionViewKey {
  legalEntityId
  viewVersion
  mutationVersion
  viewType
}
    `;
export const SessionLegalEntityBillingFieldsFragmentDoc = gql`
    fragment SessionLegalEntityBillingFields on SessionLegalEntityBilling {
  payer {
    kind
    stripeSubscription
  }
  productCoverage {
    mode
    legacy
  }
}
    `;
export const SessionLegalEntityFieldsFragmentDoc = gql`
    fragment SessionLegalEntityFields on SessionLegalEntity {
  id
  name
  slug
  iconUrl
  status
  viewKeys {
    ...SessionViewKeyFields
  }
  aspects
  affiliatedOrganizationIds
  billing {
    ...SessionLegalEntityBillingFields
  }
}
    ${SessionViewKeyFieldsFragmentDoc}
${SessionLegalEntityBillingFieldsFragmentDoc}`;
export const SessionOrganizationFieldsFragmentDoc = gql`
    fragment SessionOrganizationFields on SessionOrganization {
  id
  name
  kind
  slug
  iconUrl
  websiteUrl
  aspects
  branding {
    ...SessionOrganizationBrandingFields
  }
  billing {
    stripeSubscription
    hasStripeSubscription
  }
  legalEntities {
    ...SessionLegalEntityFields
  }
}
    ${SessionOrganizationBrandingFieldsFragmentDoc}
${SessionLegalEntityFieldsFragmentDoc}`;
export const SessionAffiliationFieldsFragmentDoc = gql`
    fragment SessionAffiliationFields on SessionAffiliation {
  id
  kind
  organization {
    ...SessionOrganizationFields
  }
}
    ${SessionOrganizationFieldsFragmentDoc}`;
export const EmploymentFieldsFragmentDoc = gql`
    fragment EmploymentFields on SessionEmployment {
  id
  organization {
    ...SessionOrganizationFields
  }
  affiliations {
    ...SessionAffiliationFields
  }
}
    ${SessionOrganizationFieldsFragmentDoc}
${SessionAffiliationFieldsFragmentDoc}`;
export const SessionFieldsFragmentDoc = gql`
    fragment SessionFields on Session {
  bearer
  employments {
    ...EmploymentFields
  }
}
    ${EmploymentFieldsFragmentDoc}`;
export const PartyPreviewFieldsFragmentDoc = gql`
    fragment PartyPreviewFields on PartyPreview {
  id
  name
  iconUrl
}
    `;
export const CategoryPreviewFieldsFragmentDoc = gql`
    fragment CategoryPreviewFields on CategoryPreview {
  name
  displayKey
  type
}
    `;
export const TransactionPreviewFieldsFragmentDoc = gql`
    fragment TransactionPreviewFields on TransactionPreview {
  timestamp
  transactionName: name
  description
  party {
    ...PartyPreviewFields
  }
  displayEntry
  creditCategory {
    ...CategoryPreviewFields
  }
  debitCategory {
    ...CategoryPreviewFields
  }
}
    ${PartyPreviewFieldsFragmentDoc}
${CategoryPreviewFieldsFragmentDoc}`;
export const PublicAddressFieldsFragmentDoc = gql`
    fragment PublicAddressFields on Address {
  street
  streetAdditional
  city
  region
  postalCode
  countryCode
  lat
  long
}
    `;
export const InvoiceAddressFieldsFragmentDoc = gql`
    fragment InvoiceAddressFields on InvoicingAddress {
  id
  address {
    ...PublicAddressFields
  }
}
    ${PublicAddressFieldsFragmentDoc}`;
export const InvoiceProfileFieldsFragmentDoc = gql`
    fragment InvoiceProfileFields on InvoicingProfile {
  id
  companyEmail
  companyName
  companyIcon
  companyAddress {
    ...InvoiceAddressFields
  }
  payoutInstrumentID
  invoiceNumberFormatDefault
  invoiceNumberFormat
}
    ${InvoiceAddressFieldsFragmentDoc}`;
export const PublicCustomerAddressFieldsFragmentDoc = gql`
    fragment PublicCustomerAddressFields on CustomerAddress {
  id
  address {
    ...PublicAddressFields
  }
}
    ${PublicAddressFieldsFragmentDoc}`;
export const PublicCustomerFieldsFragmentDoc = gql`
    fragment PublicCustomerFields on Customer {
  id
  name
  email
  icon
  address {
    ...PublicCustomerAddressFields
  }
  providerType
}
    ${PublicCustomerAddressFieldsFragmentDoc}`;
export const PublicInvoiceBrandingFieldsFragmentDoc = gql`
    fragment PublicInvoiceBrandingFields on InvoiceBranding {
  id
  backgroundColor
  coverURL
}
    `;
export const PublicDiscountFieldsFragmentDoc = gql`
    fragment PublicDiscountFields on Discount {
  discountId
  name
  fixedDiscountAmount {
    ...PublicMonetaryValueFields
  }
  variablePercentage
  providerType
}
    ${PublicMonetaryValueFieldsFragmentDoc}`;
export const PublicInvoiceDiscountFieldsFragmentDoc = gql`
    fragment PublicInvoiceDiscountFields on InvoiceDiscount {
  invoiceDiscountId
  discount {
    ...PublicDiscountFields
  }
  amount {
    ...PublicMonetaryValueFields
  }
  discountAmount {
    ...PublicMonetaryValueFields
  }
}
    ${PublicDiscountFieldsFragmentDoc}
${PublicMonetaryValueFieldsFragmentDoc}`;
export const PublicInvoiceLineItemFieldsFragmentDoc = gql`
    fragment PublicInvoiceLineItemFields on InvoiceLineItem {
  description
  id
  name
  amount {
    ...PublicMonetaryValueFields
  }
  unitPrice {
    ...PublicMonetaryValueFields
  }
  taxable
  productId
  sku
  imageUrl
  position
  discounts {
    ...PublicInvoiceDiscountFields
  }
  quantityValue {
    quantity
    quantityMultiplier
  }
}
    ${PublicMonetaryValueFieldsFragmentDoc}
${PublicInvoiceDiscountFieldsFragmentDoc}`;
export const PublicInvoiceFileFieldsFragmentDoc = gql`
    fragment PublicInvoiceFileFields on InvoiceFile {
  documentId
  fileType
}
    `;
export const InvoiceFieldsFragmentDoc = gql`
    fragment InvoiceFields on PublicInvoice {
  id
  receivableInvoiceId
  legalEntityId
  status
  invoicingProfile {
    ...InvoiceProfileFields
  }
  customer {
    ...PublicCustomerFields
  }
  branding {
    ...PublicInvoiceBrandingFields
  }
  invoiceNumber
  invoiceDate
  dueDate
  lineItems {
    ...PublicInvoiceLineItemFields
  }
  taxPercent
  totalTax {
    ...PublicMonetaryValueFields
  }
  subtotal {
    ...PublicMonetaryValueFields
  }
  totalAmount {
    ...PublicMonetaryValueFields
  }
  memo
  referenceNumber
  discounts {
    ...PublicInvoiceDiscountFields
  }
  files {
    ...PublicInvoiceFileFields
  }
}
    ${InvoiceProfileFieldsFragmentDoc}
${PublicCustomerFieldsFragmentDoc}
${PublicInvoiceBrandingFieldsFragmentDoc}
${PublicInvoiceLineItemFieldsFragmentDoc}
${PublicMonetaryValueFieldsFragmentDoc}
${PublicInvoiceDiscountFieldsFragmentDoc}
${PublicInvoiceFileFieldsFragmentDoc}`;
export const ViewInvoiceSummaryFieldsFragmentDoc = gql`
    fragment ViewInvoiceSummaryFields on ViewInvoiceSummary {
  invoice {
    ...InvoiceFields
  }
  invoicePaymentDetails {
    ...PublicInvoicePaymentDetailsFields
  }
  isPayable
  useNewPaymentProvider
  creditCardsEnabled
}
    ${InvoiceFieldsFragmentDoc}
${PublicInvoicePaymentDetailsFieldsFragmentDoc}`;
export const AddSignupDocument = gql`
    mutation AddSignup($email: String!, $givenName: String, $familyName: String, $timezone: String, $persona: Persona, $planIntent: PlanIntent!, $attribution: SignupAttribution) {
  signup: addSignup(
    email: $email
    givenName: $givenName
    familyName: $familyName
    timezone: $timezone
    persona: $persona
    planIntent: $planIntent
    attribution: $attribution
  ) {
    ...PublicSignupFields
  }
}
    ${PublicSignupFieldsFragmentDoc}`;
export type AddSignupMutationFn = Apollo.MutationFunction<AddSignupMutation, AddSignupMutationVariables>;

/**
 * __useAddSignupMutation__
 *
 * To run a mutation, you first call `useAddSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSignupMutation, { data, loading, error }] = useAddSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      timezone: // value for 'timezone'
 *      persona: // value for 'persona'
 *      planIntent: // value for 'planIntent'
 *      attribution: // value for 'attribution'
 *   },
 * });
 */
export function useAddSignupMutation(baseOptions?: Apollo.MutationHookOptions<AddSignupMutation, AddSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSignupMutation, AddSignupMutationVariables>(AddSignupDocument, options);
      }
export type AddSignupMutationHookResult = ReturnType<typeof useAddSignupMutation>;
export type AddSignupMutationResult = Apollo.MutationResult<AddSignupMutation>;
export type AddSignupMutationOptions = Apollo.BaseMutationOptions<AddSignupMutation, AddSignupMutationVariables>;
export const BeginLoginDocument = gql`
    mutation BeginLogin($emailAddress: String!, $redirectPath: String, $scheme: MagicLinkRequestScheme, $state: String) {
  beginLogin(
    emailAddress: $emailAddress
    redirectPath: $redirectPath
    scheme: $scheme
    state: $state
  ) {
    requiresSSO
    ssoIssuerURL
  }
}
    `;
export type BeginLoginMutationFn = Apollo.MutationFunction<BeginLoginMutation, BeginLoginMutationVariables>;

/**
 * __useBeginLoginMutation__
 *
 * To run a mutation, you first call `useBeginLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginLoginMutation, { data, loading, error }] = useBeginLoginMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      redirectPath: // value for 'redirectPath'
 *      scheme: // value for 'scheme'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useBeginLoginMutation(baseOptions?: Apollo.MutationHookOptions<BeginLoginMutation, BeginLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BeginLoginMutation, BeginLoginMutationVariables>(BeginLoginDocument, options);
      }
export type BeginLoginMutationHookResult = ReturnType<typeof useBeginLoginMutation>;
export type BeginLoginMutationResult = Apollo.MutationResult<BeginLoginMutation>;
export type BeginLoginMutationOptions = Apollo.BaseMutationOptions<BeginLoginMutation, BeginLoginMutationVariables>;
export const CompleteMfaChallengeDocument = gql`
    mutation CompleteMfaChallenge($challengeToken: String!, $code: String!, $method: MfaMethod!) {
  completeMfaChallenge(
    challengeToken: $challengeToken
    code: $code
    method: $method
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type CompleteMfaChallengeMutationFn = Apollo.MutationFunction<CompleteMfaChallengeMutation, CompleteMfaChallengeMutationVariables>;

/**
 * __useCompleteMfaChallengeMutation__
 *
 * To run a mutation, you first call `useCompleteMfaChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMfaChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMfaChallengeMutation, { data, loading, error }] = useCompleteMfaChallengeMutation({
 *   variables: {
 *      challengeToken: // value for 'challengeToken'
 *      code: // value for 'code'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useCompleteMfaChallengeMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMfaChallengeMutation, CompleteMfaChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMfaChallengeMutation, CompleteMfaChallengeMutationVariables>(CompleteMfaChallengeDocument, options);
      }
export type CompleteMfaChallengeMutationHookResult = ReturnType<typeof useCompleteMfaChallengeMutation>;
export type CompleteMfaChallengeMutationResult = Apollo.MutationResult<CompleteMfaChallengeMutation>;
export type CompleteMfaChallengeMutationOptions = Apollo.BaseMutationOptions<CompleteMfaChallengeMutation, CompleteMfaChallengeMutationVariables>;
export const CreatePasswordResetDocument = gql`
    mutation CreatePasswordReset($emailAddress: String!, $object: InputObjectIdentifier, $intentId: String, $ledgerBillId: String, $contactToken: String) {
  createPasswordReset(
    emailAddress: $emailAddress
    object: $object
    intentId: $intentId
    ledgerBillId: $ledgerBillId
    contactToken: $contactToken
  )
}
    `;
export type CreatePasswordResetMutationFn = Apollo.MutationFunction<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>;

/**
 * __useCreatePasswordResetMutation__
 *
 * To run a mutation, you first call `useCreatePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPasswordResetMutation, { data, loading, error }] = useCreatePasswordResetMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      object: // value for 'object'
 *      intentId: // value for 'intentId'
 *      ledgerBillId: // value for 'ledgerBillId'
 *      contactToken: // value for 'contactToken'
 *   },
 * });
 */
export function useCreatePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>(CreatePasswordResetDocument, options);
      }
export type CreatePasswordResetMutationHookResult = ReturnType<typeof useCreatePasswordResetMutation>;
export type CreatePasswordResetMutationResult = Apollo.MutationResult<CreatePasswordResetMutation>;
export type CreatePasswordResetMutationOptions = Apollo.BaseMutationOptions<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>;
export const CreatePaymentPlaidLinkTokenDocument = gql`
    mutation CreatePaymentPlaidLinkToken($plaidClientUserId: String!) {
  createPaymentPlaidLinkToken(plaidClientUserId: $plaidClientUserId) {
    token
  }
}
    `;
export type CreatePaymentPlaidLinkTokenMutationFn = Apollo.MutationFunction<CreatePaymentPlaidLinkTokenMutation, CreatePaymentPlaidLinkTokenMutationVariables>;

/**
 * __useCreatePaymentPlaidLinkTokenMutation__
 *
 * To run a mutation, you first call `useCreatePaymentPlaidLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentPlaidLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentPlaidLinkTokenMutation, { data, loading, error }] = useCreatePaymentPlaidLinkTokenMutation({
 *   variables: {
 *      plaidClientUserId: // value for 'plaidClientUserId'
 *   },
 * });
 */
export function useCreatePaymentPlaidLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentPlaidLinkTokenMutation, CreatePaymentPlaidLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentPlaidLinkTokenMutation, CreatePaymentPlaidLinkTokenMutationVariables>(CreatePaymentPlaidLinkTokenDocument, options);
      }
export type CreatePaymentPlaidLinkTokenMutationHookResult = ReturnType<typeof useCreatePaymentPlaidLinkTokenMutation>;
export type CreatePaymentPlaidLinkTokenMutationResult = Apollo.MutationResult<CreatePaymentPlaidLinkTokenMutation>;
export type CreatePaymentPlaidLinkTokenMutationOptions = Apollo.BaseMutationOptions<CreatePaymentPlaidLinkTokenMutation, CreatePaymentPlaidLinkTokenMutationVariables>;
export const CreatePlaidGuestBankAccountInstrumentDocument = gql`
    mutation CreatePlaidGuestBankAccountInstrument($invoiceId: String!, $publicToken: String!, $accountId: String!, $institutionName: String!, $useNewPaymentProvider: Boolean!) {
  createPlaidGuestBankAccountInstrument(
    invoiceId: $invoiceId
    publicToken: $publicToken
    accountId: $accountId
    institutionName: $institutionName
    useNewPaymentProvider: $useNewPaymentProvider
  ) {
    __typename
    ...PublicBankAccountFields
  }
}
    ${PublicBankAccountFieldsFragmentDoc}`;
export type CreatePlaidGuestBankAccountInstrumentMutationFn = Apollo.MutationFunction<CreatePlaidGuestBankAccountInstrumentMutation, CreatePlaidGuestBankAccountInstrumentMutationVariables>;

/**
 * __useCreatePlaidGuestBankAccountInstrumentMutation__
 *
 * To run a mutation, you first call `useCreatePlaidGuestBankAccountInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaidGuestBankAccountInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaidGuestBankAccountInstrumentMutation, { data, loading, error }] = useCreatePlaidGuestBankAccountInstrumentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      publicToken: // value for 'publicToken'
 *      accountId: // value for 'accountId'
 *      institutionName: // value for 'institutionName'
 *      useNewPaymentProvider: // value for 'useNewPaymentProvider'
 *   },
 * });
 */
export function useCreatePlaidGuestBankAccountInstrumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaidGuestBankAccountInstrumentMutation, CreatePlaidGuestBankAccountInstrumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaidGuestBankAccountInstrumentMutation, CreatePlaidGuestBankAccountInstrumentMutationVariables>(CreatePlaidGuestBankAccountInstrumentDocument, options);
      }
export type CreatePlaidGuestBankAccountInstrumentMutationHookResult = ReturnType<typeof useCreatePlaidGuestBankAccountInstrumentMutation>;
export type CreatePlaidGuestBankAccountInstrumentMutationResult = Apollo.MutationResult<CreatePlaidGuestBankAccountInstrumentMutation>;
export type CreatePlaidGuestBankAccountInstrumentMutationOptions = Apollo.BaseMutationOptions<CreatePlaidGuestBankAccountInstrumentMutation, CreatePlaidGuestBankAccountInstrumentMutationVariables>;
export const HandleInvoiceCardPaymentActionDocument = gql`
    mutation HandleInvoiceCardPaymentAction($invoiceId: String!, $paymentDetails: String!, $billingAddress: CardBillingAddressInput) {
  handleInvoiceCardPaymentAction(
    invoiceId: $invoiceId
    paymentDetails: $paymentDetails
    billingAddress: $billingAddress
  ) {
    result
    paymentConfirmationId
    pspReference
    errorMessage
    cardBrand
    cardLastFour
  }
}
    `;
export type HandleInvoiceCardPaymentActionMutationFn = Apollo.MutationFunction<HandleInvoiceCardPaymentActionMutation, HandleInvoiceCardPaymentActionMutationVariables>;

/**
 * __useHandleInvoiceCardPaymentActionMutation__
 *
 * To run a mutation, you first call `useHandleInvoiceCardPaymentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleInvoiceCardPaymentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleInvoiceCardPaymentActionMutation, { data, loading, error }] = useHandleInvoiceCardPaymentActionMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentDetails: // value for 'paymentDetails'
 *      billingAddress: // value for 'billingAddress'
 *   },
 * });
 */
export function useHandleInvoiceCardPaymentActionMutation(baseOptions?: Apollo.MutationHookOptions<HandleInvoiceCardPaymentActionMutation, HandleInvoiceCardPaymentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleInvoiceCardPaymentActionMutation, HandleInvoiceCardPaymentActionMutationVariables>(HandleInvoiceCardPaymentActionDocument, options);
      }
export type HandleInvoiceCardPaymentActionMutationHookResult = ReturnType<typeof useHandleInvoiceCardPaymentActionMutation>;
export type HandleInvoiceCardPaymentActionMutationResult = Apollo.MutationResult<HandleInvoiceCardPaymentActionMutation>;
export type HandleInvoiceCardPaymentActionMutationOptions = Apollo.BaseMutationOptions<HandleInvoiceCardPaymentActionMutation, HandleInvoiceCardPaymentActionMutationVariables>;
export const LedgerHandleInvoiceCardPaymentActionDocument = gql`
    mutation LedgerHandleInvoiceCardPaymentAction($invoiceId: String!, $paymentDetails: String!, $billingAddress: CardBillingAddressInput, $expectedAmount: InputMonetaryValue!) {
  ledgerHandleInvoiceCardPaymentAction(
    invoiceId: $invoiceId
    paymentDetails: $paymentDetails
    billingAddress: $billingAddress
    expectedAmount: $expectedAmount
  ) {
    result
    paymentConfirmationId
    pspReference
    errorMessage
    cardBrand
    cardLastFour
  }
}
    `;
export type LedgerHandleInvoiceCardPaymentActionMutationFn = Apollo.MutationFunction<LedgerHandleInvoiceCardPaymentActionMutation, LedgerHandleInvoiceCardPaymentActionMutationVariables>;

/**
 * __useLedgerHandleInvoiceCardPaymentActionMutation__
 *
 * To run a mutation, you first call `useLedgerHandleInvoiceCardPaymentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerHandleInvoiceCardPaymentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerHandleInvoiceCardPaymentActionMutation, { data, loading, error }] = useLedgerHandleInvoiceCardPaymentActionMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentDetails: // value for 'paymentDetails'
 *      billingAddress: // value for 'billingAddress'
 *      expectedAmount: // value for 'expectedAmount'
 *   },
 * });
 */
export function useLedgerHandleInvoiceCardPaymentActionMutation(baseOptions?: Apollo.MutationHookOptions<LedgerHandleInvoiceCardPaymentActionMutation, LedgerHandleInvoiceCardPaymentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerHandleInvoiceCardPaymentActionMutation, LedgerHandleInvoiceCardPaymentActionMutationVariables>(LedgerHandleInvoiceCardPaymentActionDocument, options);
      }
export type LedgerHandleInvoiceCardPaymentActionMutationHookResult = ReturnType<typeof useLedgerHandleInvoiceCardPaymentActionMutation>;
export type LedgerHandleInvoiceCardPaymentActionMutationResult = Apollo.MutationResult<LedgerHandleInvoiceCardPaymentActionMutation>;
export type LedgerHandleInvoiceCardPaymentActionMutationOptions = Apollo.BaseMutationOptions<LedgerHandleInvoiceCardPaymentActionMutation, LedgerHandleInvoiceCardPaymentActionMutationVariables>;
export const LedgerPayInvoiceDocument = gql`
    mutation LedgerPayInvoice($invoiceId: String!, $paymentInstrumentId: String!, $expectedAmount: InputMonetaryValue!) {
  ledgerPayInvoice(
    invoiceId: $invoiceId
    paymentInstrumentId: $paymentInstrumentId
    expectedAmount: $expectedAmount
  ) {
    ...PublicPayInvoiceSummaryFields
  }
}
    ${PublicPayInvoiceSummaryFieldsFragmentDoc}`;
export type LedgerPayInvoiceMutationFn = Apollo.MutationFunction<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>;

/**
 * __useLedgerPayInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerPayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerPayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerPayInvoiceMutation, { data, loading, error }] = useLedgerPayInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      expectedAmount: // value for 'expectedAmount'
 *   },
 * });
 */
export function useLedgerPayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>(LedgerPayInvoiceDocument, options);
      }
export type LedgerPayInvoiceMutationHookResult = ReturnType<typeof useLedgerPayInvoiceMutation>;
export type LedgerPayInvoiceMutationResult = Apollo.MutationResult<LedgerPayInvoiceMutation>;
export type LedgerPayInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>;
export const LedgerSubmitInvoiceCardPaymentDocument = gql`
    mutation LedgerSubmitInvoiceCardPayment($invoiceId: String!, $paymentMethodData: String!, $returnUrl: String!, $browserInfo: String, $riskData: String, $billingAddress: CardBillingAddressInput, $holderName: String, $expectedAmount: InputMonetaryValue!, $requestedTestAcquirerResponseCode: String) {
  ledgerSubmitInvoiceCardPayment(
    invoiceId: $invoiceId
    paymentMethodData: $paymentMethodData
    returnUrl: $returnUrl
    browserInfo: $browserInfo
    riskData: $riskData
    billingAddress: $billingAddress
    holderName: $holderName
    expectedAmount: $expectedAmount
    requestedTestAcquirerResponseCode: $requestedTestAcquirerResponseCode
  ) {
    result
    paymentConfirmationId
    pspReference
    actionData
    errorMessage
    refusalReasonCode
    cardBrand
    cardLastFour
  }
}
    `;
export type LedgerSubmitInvoiceCardPaymentMutationFn = Apollo.MutationFunction<LedgerSubmitInvoiceCardPaymentMutation, LedgerSubmitInvoiceCardPaymentMutationVariables>;

/**
 * __useLedgerSubmitInvoiceCardPaymentMutation__
 *
 * To run a mutation, you first call `useLedgerSubmitInvoiceCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSubmitInvoiceCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSubmitInvoiceCardPaymentMutation, { data, loading, error }] = useLedgerSubmitInvoiceCardPaymentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentMethodData: // value for 'paymentMethodData'
 *      returnUrl: // value for 'returnUrl'
 *      browserInfo: // value for 'browserInfo'
 *      riskData: // value for 'riskData'
 *      billingAddress: // value for 'billingAddress'
 *      holderName: // value for 'holderName'
 *      expectedAmount: // value for 'expectedAmount'
 *      requestedTestAcquirerResponseCode: // value for 'requestedTestAcquirerResponseCode'
 *   },
 * });
 */
export function useLedgerSubmitInvoiceCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSubmitInvoiceCardPaymentMutation, LedgerSubmitInvoiceCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSubmitInvoiceCardPaymentMutation, LedgerSubmitInvoiceCardPaymentMutationVariables>(LedgerSubmitInvoiceCardPaymentDocument, options);
      }
export type LedgerSubmitInvoiceCardPaymentMutationHookResult = ReturnType<typeof useLedgerSubmitInvoiceCardPaymentMutation>;
export type LedgerSubmitInvoiceCardPaymentMutationResult = Apollo.MutationResult<LedgerSubmitInvoiceCardPaymentMutation>;
export type LedgerSubmitInvoiceCardPaymentMutationOptions = Apollo.BaseMutationOptions<LedgerSubmitInvoiceCardPaymentMutation, LedgerSubmitInvoiceCardPaymentMutationVariables>;
export const LogInAppInstanceDocument = gql`
    mutation LogInAppInstance($id: String!, $challenge: AppInstanceChallenge!, $profile: AppInstanceProfile!, $activeLegalEntityId: String) {
  logInAppInstance(
    id: $id
    challenge: $challenge
    profile: $profile
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInAppInstanceMutationFn = Apollo.MutationFunction<LogInAppInstanceMutation, LogInAppInstanceMutationVariables>;

/**
 * __useLogInAppInstanceMutation__
 *
 * To run a mutation, you first call `useLogInAppInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInAppInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInAppInstanceMutation, { data, loading, error }] = useLogInAppInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      challenge: // value for 'challenge'
 *      profile: // value for 'profile'
 *      activeLegalEntityId: // value for 'activeLegalEntityId'
 *   },
 * });
 */
export function useLogInAppInstanceMutation(baseOptions?: Apollo.MutationHookOptions<LogInAppInstanceMutation, LogInAppInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInAppInstanceMutation, LogInAppInstanceMutationVariables>(LogInAppInstanceDocument, options);
      }
export type LogInAppInstanceMutationHookResult = ReturnType<typeof useLogInAppInstanceMutation>;
export type LogInAppInstanceMutationResult = Apollo.MutationResult<LogInAppInstanceMutation>;
export type LogInAppInstanceMutationOptions = Apollo.BaseMutationOptions<LogInAppInstanceMutation, LogInAppInstanceMutationVariables>;
export const LogInEmailDocument = gql`
    mutation LogInEmail($emailAddress: String!, $password: String!, $activeLegalEntityId: String) {
  logInEmail(
    emailAddress: $emailAddress
    password: $password
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInEmailMutationFn = Apollo.MutationFunction<LogInEmailMutation, LogInEmailMutationVariables>;

/**
 * __useLogInEmailMutation__
 *
 * To run a mutation, you first call `useLogInEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInEmailMutation, { data, loading, error }] = useLogInEmailMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      password: // value for 'password'
 *      activeLegalEntityId: // value for 'activeLegalEntityId'
 *   },
 * });
 */
export function useLogInEmailMutation(baseOptions?: Apollo.MutationHookOptions<LogInEmailMutation, LogInEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInEmailMutation, LogInEmailMutationVariables>(LogInEmailDocument, options);
      }
export type LogInEmailMutationHookResult = ReturnType<typeof useLogInEmailMutation>;
export type LogInEmailMutationResult = Apollo.MutationResult<LogInEmailMutation>;
export type LogInEmailMutationOptions = Apollo.BaseMutationOptions<LogInEmailMutation, LogInEmailMutationVariables>;
export const LogInMagicLinkDocument = gql`
    mutation LogInMagicLink($token: String!, $state: String, $activeLegalEntityId: String) {
  logInMagicLink(
    token: $token
    state: $state
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInMagicLinkMutationFn = Apollo.MutationFunction<LogInMagicLinkMutation, LogInMagicLinkMutationVariables>;

/**
 * __useLogInMagicLinkMutation__
 *
 * To run a mutation, you first call `useLogInMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInMagicLinkMutation, { data, loading, error }] = useLogInMagicLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *      state: // value for 'state'
 *      activeLegalEntityId: // value for 'activeLegalEntityId'
 *   },
 * });
 */
export function useLogInMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<LogInMagicLinkMutation, LogInMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInMagicLinkMutation, LogInMagicLinkMutationVariables>(LogInMagicLinkDocument, options);
      }
export type LogInMagicLinkMutationHookResult = ReturnType<typeof useLogInMagicLinkMutation>;
export type LogInMagicLinkMutationResult = Apollo.MutationResult<LogInMagicLinkMutation>;
export type LogInMagicLinkMutationOptions = Apollo.BaseMutationOptions<LogInMagicLinkMutation, LogInMagicLinkMutationVariables>;
export const LogInOAuthDocument = gql`
    mutation LogInOAuth($service: OAuthService!, $code: String!, $activeLegalEntityId: String) {
  logInOAuth(
    service: $service
    code: $code
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInOAuthMutationFn = Apollo.MutationFunction<LogInOAuthMutation, LogInOAuthMutationVariables>;

/**
 * __useLogInOAuthMutation__
 *
 * To run a mutation, you first call `useLogInOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInOAuthMutation, { data, loading, error }] = useLogInOAuthMutation({
 *   variables: {
 *      service: // value for 'service'
 *      code: // value for 'code'
 *      activeLegalEntityId: // value for 'activeLegalEntityId'
 *   },
 * });
 */
export function useLogInOAuthMutation(baseOptions?: Apollo.MutationHookOptions<LogInOAuthMutation, LogInOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInOAuthMutation, LogInOAuthMutationVariables>(LogInOAuthDocument, options);
      }
export type LogInOAuthMutationHookResult = ReturnType<typeof useLogInOAuthMutation>;
export type LogInOAuthMutationResult = Apollo.MutationResult<LogInOAuthMutation>;
export type LogInOAuthMutationOptions = Apollo.BaseMutationOptions<LogInOAuthMutation, LogInOAuthMutationVariables>;
export const LogInSupportDocument = gql`
    mutation LogInSupport($id: String!) {
  logInSupport(id: $id) {
    bearer
  }
}
    `;
export type LogInSupportMutationFn = Apollo.MutationFunction<LogInSupportMutation, LogInSupportMutationVariables>;

/**
 * __useLogInSupportMutation__
 *
 * To run a mutation, you first call `useLogInSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInSupportMutation, { data, loading, error }] = useLogInSupportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLogInSupportMutation(baseOptions?: Apollo.MutationHookOptions<LogInSupportMutation, LogInSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInSupportMutation, LogInSupportMutationVariables>(LogInSupportDocument, options);
      }
export type LogInSupportMutationHookResult = ReturnType<typeof useLogInSupportMutation>;
export type LogInSupportMutationResult = Apollo.MutationResult<LogInSupportMutation>;
export type LogInSupportMutationOptions = Apollo.BaseMutationOptions<LogInSupportMutation, LogInSupportMutationVariables>;
export const LogOutSupportDocument = gql`
    mutation LogOutSupport($id: String!) {
  logOutSupport(id: $id) {
    bearer
  }
}
    `;
export type LogOutSupportMutationFn = Apollo.MutationFunction<LogOutSupportMutation, LogOutSupportMutationVariables>;

/**
 * __useLogOutSupportMutation__
 *
 * To run a mutation, you first call `useLogOutSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOutSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOutSupportMutation, { data, loading, error }] = useLogOutSupportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLogOutSupportMutation(baseOptions?: Apollo.MutationHookOptions<LogOutSupportMutation, LogOutSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOutSupportMutation, LogOutSupportMutationVariables>(LogOutSupportDocument, options);
      }
export type LogOutSupportMutationHookResult = ReturnType<typeof useLogOutSupportMutation>;
export type LogOutSupportMutationResult = Apollo.MutationResult<LogOutSupportMutation>;
export type LogOutSupportMutationOptions = Apollo.BaseMutationOptions<LogOutSupportMutation, LogOutSupportMutationVariables>;
export const PayInvoiceDocument = gql`
    mutation PayInvoice($invoiceId: String!, $receivableInvoiceId: String, $paymentInstrumentId: String!) {
  payInvoice(
    invoiceId: $invoiceId
    receivableInvoiceId: $receivableInvoiceId
    paymentInstrumentId: $paymentInstrumentId
  ) {
    ...PublicPayInvoiceSummaryFields
  }
}
    ${PublicPayInvoiceSummaryFieldsFragmentDoc}`;
export type PayInvoiceMutationFn = Apollo.MutationFunction<PayInvoiceMutation, PayInvoiceMutationVariables>;

/**
 * __usePayInvoiceMutation__
 *
 * To run a mutation, you first call `usePayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceMutation, { data, loading, error }] = usePayInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      receivableInvoiceId: // value for 'receivableInvoiceId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *   },
 * });
 */
export function usePayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PayInvoiceMutation, PayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayInvoiceMutation, PayInvoiceMutationVariables>(PayInvoiceDocument, options);
      }
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<PayInvoiceMutation>;
export type PayInvoiceMutationOptions = Apollo.BaseMutationOptions<PayInvoiceMutation, PayInvoiceMutationVariables>;
export const ProvisionVerificationTokenDocument = gql`
    mutation ProvisionVerificationToken($emailAddress: String!, $givenName: String!, $familyName: String!, $object: InputObjectIdentifier!, $intentId: String!) {
  provisionVerificationToken(
    givenName: $givenName
    familyName: $familyName
    emailAddress: $emailAddress
    object: $object
    intentId: $intentId
  ) {
    token
  }
}
    `;
export type ProvisionVerificationTokenMutationFn = Apollo.MutationFunction<ProvisionVerificationTokenMutation, ProvisionVerificationTokenMutationVariables>;

/**
 * __useProvisionVerificationTokenMutation__
 *
 * To run a mutation, you first call `useProvisionVerificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionVerificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionVerificationTokenMutation, { data, loading, error }] = useProvisionVerificationTokenMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      object: // value for 'object'
 *      intentId: // value for 'intentId'
 *   },
 * });
 */
export function useProvisionVerificationTokenMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionVerificationTokenMutation, ProvisionVerificationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionVerificationTokenMutation, ProvisionVerificationTokenMutationVariables>(ProvisionVerificationTokenDocument, options);
      }
export type ProvisionVerificationTokenMutationHookResult = ReturnType<typeof useProvisionVerificationTokenMutation>;
export type ProvisionVerificationTokenMutationResult = Apollo.MutationResult<ProvisionVerificationTokenMutation>;
export type ProvisionVerificationTokenMutationOptions = Apollo.BaseMutationOptions<ProvisionVerificationTokenMutation, ProvisionVerificationTokenMutationVariables>;
export const RegisterInviteOAuthDocument = gql`
    mutation RegisterInviteOAuth($invitationToken: String!, $timezone: String!, $code: String!, $service: OAuthService!) {
  registerInviteOAuth(
    invitationToken: $invitationToken
    timezone: $timezone
    code: $code
    service: $service
  ) {
    bearer
  }
}
    `;
export type RegisterInviteOAuthMutationFn = Apollo.MutationFunction<RegisterInviteOAuthMutation, RegisterInviteOAuthMutationVariables>;

/**
 * __useRegisterInviteOAuthMutation__
 *
 * To run a mutation, you first call `useRegisterInviteOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterInviteOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerInviteOAuthMutation, { data, loading, error }] = useRegisterInviteOAuthMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *      timezone: // value for 'timezone'
 *      code: // value for 'code'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useRegisterInviteOAuthMutation(baseOptions?: Apollo.MutationHookOptions<RegisterInviteOAuthMutation, RegisterInviteOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterInviteOAuthMutation, RegisterInviteOAuthMutationVariables>(RegisterInviteOAuthDocument, options);
      }
export type RegisterInviteOAuthMutationHookResult = ReturnType<typeof useRegisterInviteOAuthMutation>;
export type RegisterInviteOAuthMutationResult = Apollo.MutationResult<RegisterInviteOAuthMutation>;
export type RegisterInviteOAuthMutationOptions = Apollo.BaseMutationOptions<RegisterInviteOAuthMutation, RegisterInviteOAuthMutationVariables>;
export const RegisterInvitePasswordlessDocument = gql`
    mutation RegisterInvitePasswordless($invitationToken: String!, $timezone: String!, $tosVersionAccepted: String, $givenName: String, $familyName: String) {
  registerInvitePasswordless(
    invitationToken: $invitationToken
    timezone: $timezone
    tosVersionAccepted: $tosVersionAccepted
    givenName: $givenName
    familyName: $familyName
  ) {
    bearer
  }
}
    `;
export type RegisterInvitePasswordlessMutationFn = Apollo.MutationFunction<RegisterInvitePasswordlessMutation, RegisterInvitePasswordlessMutationVariables>;

/**
 * __useRegisterInvitePasswordlessMutation__
 *
 * To run a mutation, you first call `useRegisterInvitePasswordlessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterInvitePasswordlessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerInvitePasswordlessMutation, { data, loading, error }] = useRegisterInvitePasswordlessMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *      timezone: // value for 'timezone'
 *      tosVersionAccepted: // value for 'tosVersionAccepted'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *   },
 * });
 */
export function useRegisterInvitePasswordlessMutation(baseOptions?: Apollo.MutationHookOptions<RegisterInvitePasswordlessMutation, RegisterInvitePasswordlessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterInvitePasswordlessMutation, RegisterInvitePasswordlessMutationVariables>(RegisterInvitePasswordlessDocument, options);
      }
export type RegisterInvitePasswordlessMutationHookResult = ReturnType<typeof useRegisterInvitePasswordlessMutation>;
export type RegisterInvitePasswordlessMutationResult = Apollo.MutationResult<RegisterInvitePasswordlessMutation>;
export type RegisterInvitePasswordlessMutationOptions = Apollo.BaseMutationOptions<RegisterInvitePasswordlessMutation, RegisterInvitePasswordlessMutationVariables>;
export const RegisterUserEmailTokenDocument = gql`
    mutation RegisterUserEmailToken($confirmToken: String!, $timezone: String!, $password: String, $tosVersionAccepted: String, $givenName: String, $familyName: String) {
  registerUserEmailToken(
    confirmToken: $confirmToken
    timezone: $timezone
    password: $password
    tosVersionAccepted: $tosVersionAccepted
    givenName: $givenName
    familyName: $familyName
  ) {
    session {
      ...SessionFields
    }
    alreadyRegistered
  }
}
    ${SessionFieldsFragmentDoc}`;
export type RegisterUserEmailTokenMutationFn = Apollo.MutationFunction<RegisterUserEmailTokenMutation, RegisterUserEmailTokenMutationVariables>;

/**
 * __useRegisterUserEmailTokenMutation__
 *
 * To run a mutation, you first call `useRegisterUserEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserEmailTokenMutation, { data, loading, error }] = useRegisterUserEmailTokenMutation({
 *   variables: {
 *      confirmToken: // value for 'confirmToken'
 *      timezone: // value for 'timezone'
 *      password: // value for 'password'
 *      tosVersionAccepted: // value for 'tosVersionAccepted'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *   },
 * });
 */
export function useRegisterUserEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserEmailTokenMutation, RegisterUserEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserEmailTokenMutation, RegisterUserEmailTokenMutationVariables>(RegisterUserEmailTokenDocument, options);
      }
export type RegisterUserEmailTokenMutationHookResult = ReturnType<typeof useRegisterUserEmailTokenMutation>;
export type RegisterUserEmailTokenMutationResult = Apollo.MutationResult<RegisterUserEmailTokenMutation>;
export type RegisterUserEmailTokenMutationOptions = Apollo.BaseMutationOptions<RegisterUserEmailTokenMutation, RegisterUserEmailTokenMutationVariables>;
export const RegisterUserOAuthDocument = gql`
    mutation RegisterUserOAuth($service: OAuthService!, $code: String!, $timezone: String!, $tosVersionAccepted: String) {
  registerUserOAuth(
    service: $service
    code: $code
    timezone: $timezone
    tosVersionAccepted: $tosVersionAccepted
  ) {
    bearer
  }
}
    `;
export type RegisterUserOAuthMutationFn = Apollo.MutationFunction<RegisterUserOAuthMutation, RegisterUserOAuthMutationVariables>;

/**
 * __useRegisterUserOAuthMutation__
 *
 * To run a mutation, you first call `useRegisterUserOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserOAuthMutation, { data, loading, error }] = useRegisterUserOAuthMutation({
 *   variables: {
 *      service: // value for 'service'
 *      code: // value for 'code'
 *      timezone: // value for 'timezone'
 *      tosVersionAccepted: // value for 'tosVersionAccepted'
 *   },
 * });
 */
export function useRegisterUserOAuthMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserOAuthMutation, RegisterUserOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserOAuthMutation, RegisterUserOAuthMutationVariables>(RegisterUserOAuthDocument, options);
      }
export type RegisterUserOAuthMutationHookResult = ReturnType<typeof useRegisterUserOAuthMutation>;
export type RegisterUserOAuthMutationResult = Apollo.MutationResult<RegisterUserOAuthMutation>;
export type RegisterUserOAuthMutationOptions = Apollo.BaseMutationOptions<RegisterUserOAuthMutation, RegisterUserOAuthMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetToken: String!, $newPassword: String!) {
  resetPassword(resetToken: $resetToken, newPassword: $newPassword) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetToken: // value for 'resetToken'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendAcceptedInvitationMagicLinkDocument = gql`
    mutation SendAcceptedInvitationMagicLink($invitationToken: String!, $redirectPath: String, $scheme: MagicLinkRequestScheme, $state: String) {
  sendAcceptedInvitationMagicLink(
    invitationToken: $invitationToken
    redirectPath: $redirectPath
    scheme: $scheme
    state: $state
  )
}
    `;
export type SendAcceptedInvitationMagicLinkMutationFn = Apollo.MutationFunction<SendAcceptedInvitationMagicLinkMutation, SendAcceptedInvitationMagicLinkMutationVariables>;

/**
 * __useSendAcceptedInvitationMagicLinkMutation__
 *
 * To run a mutation, you first call `useSendAcceptedInvitationMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAcceptedInvitationMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAcceptedInvitationMagicLinkMutation, { data, loading, error }] = useSendAcceptedInvitationMagicLinkMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *      redirectPath: // value for 'redirectPath'
 *      scheme: // value for 'scheme'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSendAcceptedInvitationMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendAcceptedInvitationMagicLinkMutation, SendAcceptedInvitationMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAcceptedInvitationMagicLinkMutation, SendAcceptedInvitationMagicLinkMutationVariables>(SendAcceptedInvitationMagicLinkDocument, options);
      }
export type SendAcceptedInvitationMagicLinkMutationHookResult = ReturnType<typeof useSendAcceptedInvitationMagicLinkMutation>;
export type SendAcceptedInvitationMagicLinkMutationResult = Apollo.MutationResult<SendAcceptedInvitationMagicLinkMutation>;
export type SendAcceptedInvitationMagicLinkMutationOptions = Apollo.BaseMutationOptions<SendAcceptedInvitationMagicLinkMutation, SendAcceptedInvitationMagicLinkMutationVariables>;
export const SendEmailVerificationDocument = gql`
    mutation SendEmailVerification($emailAddress: String!, $givenName: String, $familyName: String, $destination: VerificationRequestDestination!, $object: InputObjectIdentifier, $intentId: String, $constraint: AccessConstraint, $billId: String, $contactToken: String, $requestParameters: [RequestParameter!]) {
  sendEmailVerification(
    givenName: $givenName
    familyName: $familyName
    emailAddress: $emailAddress
    destination: $destination
    object: $object
    intentId: $intentId
    constraint: $constraint
    billId: $billId
    contactToken: $contactToken
    requestParameters: $requestParameters
  )
}
    `;
export type SendEmailVerificationMutationFn = Apollo.MutationFunction<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;

/**
 * __useSendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useSendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailVerificationMutation, { data, loading, error }] = useSendEmailVerificationMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      destination: // value for 'destination'
 *      object: // value for 'object'
 *      intentId: // value for 'intentId'
 *      constraint: // value for 'constraint'
 *      billId: // value for 'billId'
 *      contactToken: // value for 'contactToken'
 *      requestParameters: // value for 'requestParameters'
 *   },
 * });
 */
export function useSendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument, options);
      }
export type SendEmailVerificationMutationHookResult = ReturnType<typeof useSendEmailVerificationMutation>;
export type SendEmailVerificationMutationResult = Apollo.MutationResult<SendEmailVerificationMutation>;
export type SendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;
export const SendMagicLinkEmailDocument = gql`
    mutation SendMagicLinkEmail($emailAddress: String!, $redirectPath: String, $scheme: MagicLinkRequestScheme, $state: String) {
  sendMagicLinkEmail(
    emailAddress: $emailAddress
    redirectPath: $redirectPath
    scheme: $scheme
    state: $state
  )
}
    `;
export type SendMagicLinkEmailMutationFn = Apollo.MutationFunction<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>;

/**
 * __useSendMagicLinkEmailMutation__
 *
 * To run a mutation, you first call `useSendMagicLinkEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMagicLinkEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMagicLinkEmailMutation, { data, loading, error }] = useSendMagicLinkEmailMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      redirectPath: // value for 'redirectPath'
 *      scheme: // value for 'scheme'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSendMagicLinkEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>(SendMagicLinkEmailDocument, options);
      }
export type SendMagicLinkEmailMutationHookResult = ReturnType<typeof useSendMagicLinkEmailMutation>;
export type SendMagicLinkEmailMutationResult = Apollo.MutationResult<SendMagicLinkEmailMutation>;
export type SendMagicLinkEmailMutationOptions = Apollo.BaseMutationOptions<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>;
export const SubmitInvoiceCardPaymentDocument = gql`
    mutation SubmitInvoiceCardPayment($invoiceId: String!, $paymentMethodData: String!, $returnUrl: String!, $browserInfo: String, $riskData: String, $billingAddress: CardBillingAddressInput, $holderName: String, $requestedTestAcquirerResponseCode: String) {
  submitInvoiceCardPayment(
    invoiceId: $invoiceId
    paymentMethodData: $paymentMethodData
    returnUrl: $returnUrl
    browserInfo: $browserInfo
    riskData: $riskData
    billingAddress: $billingAddress
    holderName: $holderName
    requestedTestAcquirerResponseCode: $requestedTestAcquirerResponseCode
  ) {
    result
    paymentConfirmationId
    pspReference
    actionData
    errorMessage
    refusalReasonCode
    cardBrand
    cardLastFour
  }
}
    `;
export type SubmitInvoiceCardPaymentMutationFn = Apollo.MutationFunction<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>;

/**
 * __useSubmitInvoiceCardPaymentMutation__
 *
 * To run a mutation, you first call `useSubmitInvoiceCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitInvoiceCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitInvoiceCardPaymentMutation, { data, loading, error }] = useSubmitInvoiceCardPaymentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentMethodData: // value for 'paymentMethodData'
 *      returnUrl: // value for 'returnUrl'
 *      browserInfo: // value for 'browserInfo'
 *      riskData: // value for 'riskData'
 *      billingAddress: // value for 'billingAddress'
 *      holderName: // value for 'holderName'
 *      requestedTestAcquirerResponseCode: // value for 'requestedTestAcquirerResponseCode'
 *   },
 * });
 */
export function useSubmitInvoiceCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>(SubmitInvoiceCardPaymentDocument, options);
      }
export type SubmitInvoiceCardPaymentMutationHookResult = ReturnType<typeof useSubmitInvoiceCardPaymentMutation>;
export type SubmitInvoiceCardPaymentMutationResult = Apollo.MutationResult<SubmitInvoiceCardPaymentMutation>;
export type SubmitInvoiceCardPaymentMutationOptions = Apollo.BaseMutationOptions<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>;
export const TokenRefreshDocument = gql`
    mutation TokenRefresh($activeLegalEntityId: String) {
  tokenRefresh(activeLegalEntityId: $activeLegalEntityId) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type TokenRefreshMutationFn = Apollo.MutationFunction<TokenRefreshMutation, TokenRefreshMutationVariables>;

/**
 * __useTokenRefreshMutation__
 *
 * To run a mutation, you first call `useTokenRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenRefreshMutation, { data, loading, error }] = useTokenRefreshMutation({
 *   variables: {
 *      activeLegalEntityId: // value for 'activeLegalEntityId'
 *   },
 * });
 */
export function useTokenRefreshMutation(baseOptions?: Apollo.MutationHookOptions<TokenRefreshMutation, TokenRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TokenRefreshMutation, TokenRefreshMutationVariables>(TokenRefreshDocument, options);
      }
export type TokenRefreshMutationHookResult = ReturnType<typeof useTokenRefreshMutation>;
export type TokenRefreshMutationResult = Apollo.MutationResult<TokenRefreshMutation>;
export type TokenRefreshMutationOptions = Apollo.BaseMutationOptions<TokenRefreshMutation, TokenRefreshMutationVariables>;
export const UnsubscribeDocument = gql`
    mutation Unsubscribe($emailAddress: String!, $notificationToken: String!) {
  unsubscribe(emailAddress: $emailAddress, notificationToken: $notificationToken)
}
    `;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;

/**
 * __useUnsubscribeMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMutation, { data, loading, error }] = useUnsubscribeMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      notificationToken: // value for 'notificationToken'
 *   },
 * });
 */
export function useUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, options);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const GetInvoicePaymentMethodsDocument = gql`
    query GetInvoicePaymentMethods($invoiceId: String!, $amount: InputMonetaryValue!, $payerLegalEntityId: String, $invoiceLegalEntityId: String!) {
  getInvoicePaymentMethods(
    invoiceId: $invoiceId
    amount: $amount
    payerLegalEntityId: $payerLegalEntityId
    invoiceLegalEntityId: $invoiceLegalEntityId
  ) {
    clientKey
    environment
    paymentMethodsResponse
  }
}
    `;

/**
 * __useGetInvoicePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetInvoicePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePaymentMethodsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      amount: // value for 'amount'
 *      payerLegalEntityId: // value for 'payerLegalEntityId'
 *      invoiceLegalEntityId: // value for 'invoiceLegalEntityId'
 *   },
 * });
 */
export function useGetInvoicePaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables> & ({ variables: GetInvoicePaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>(GetInvoicePaymentMethodsDocument, options);
      }
export function useGetInvoicePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>(GetInvoicePaymentMethodsDocument, options);
        }
export function useGetInvoicePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>(GetInvoicePaymentMethodsDocument, options);
        }
export type GetInvoicePaymentMethodsQueryHookResult = ReturnType<typeof useGetInvoicePaymentMethodsQuery>;
export type GetInvoicePaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetInvoicePaymentMethodsLazyQuery>;
export type GetInvoicePaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetInvoicePaymentMethodsSuspenseQuery>;
export type GetInvoicePaymentMethodsQueryResult = Apollo.QueryResult<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>;
export const LedgerBillIdForBillPaymentDocument = gql`
    query LedgerBillIdForBillPayment($billPaymentId: String!, $contactToken: String!) {
  previewBillPayment(id: $billPaymentId, contactToken: $contactToken) {
    billId
    id
  }
}
    `;

/**
 * __useLedgerBillIdForBillPaymentQuery__
 *
 * To run a query within a React component, call `useLedgerBillIdForBillPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerBillIdForBillPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerBillIdForBillPaymentQuery({
 *   variables: {
 *      billPaymentId: // value for 'billPaymentId'
 *      contactToken: // value for 'contactToken'
 *   },
 * });
 */
export function useLedgerBillIdForBillPaymentQuery(baseOptions: Apollo.QueryHookOptions<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables> & ({ variables: LedgerBillIdForBillPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>(LedgerBillIdForBillPaymentDocument, options);
      }
export function useLedgerBillIdForBillPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>(LedgerBillIdForBillPaymentDocument, options);
        }
export function useLedgerBillIdForBillPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>(LedgerBillIdForBillPaymentDocument, options);
        }
export type LedgerBillIdForBillPaymentQueryHookResult = ReturnType<typeof useLedgerBillIdForBillPaymentQuery>;
export type LedgerBillIdForBillPaymentLazyQueryHookResult = ReturnType<typeof useLedgerBillIdForBillPaymentLazyQuery>;
export type LedgerBillIdForBillPaymentSuspenseQueryHookResult = ReturnType<typeof useLedgerBillIdForBillPaymentSuspenseQuery>;
export type LedgerBillIdForBillPaymentQueryResult = Apollo.QueryResult<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>;
export const PreviewLedgerBillDocument = gql`
    query PreviewLedgerBill($id: String!, $contactToken: String!) {
  previewLedgerBill(id: $id, contactToken: $contactToken) {
    ...PublicLedgerBillPreviewFields
  }
}
    ${PublicLedgerBillPreviewFieldsFragmentDoc}`;

/**
 * __usePreviewLedgerBillQuery__
 *
 * To run a query within a React component, call `usePreviewLedgerBillQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewLedgerBillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewLedgerBillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contactToken: // value for 'contactToken'
 *   },
 * });
 */
export function usePreviewLedgerBillQuery(baseOptions: Apollo.QueryHookOptions<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables> & ({ variables: PreviewLedgerBillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>(PreviewLedgerBillDocument, options);
      }
export function usePreviewLedgerBillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>(PreviewLedgerBillDocument, options);
        }
export function usePreviewLedgerBillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>(PreviewLedgerBillDocument, options);
        }
export type PreviewLedgerBillQueryHookResult = ReturnType<typeof usePreviewLedgerBillQuery>;
export type PreviewLedgerBillLazyQueryHookResult = ReturnType<typeof usePreviewLedgerBillLazyQuery>;
export type PreviewLedgerBillSuspenseQueryHookResult = ReturnType<typeof usePreviewLedgerBillSuspenseQuery>;
export type PreviewLedgerBillQueryResult = Apollo.QueryResult<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>;
export const PreviewShareDocument = gql`
    query PreviewShare($kind: ObjectKind!, $id: String!, $intentId: String) {
  previewShare(kind: $kind, id: $id, intentId: $intentId) {
    legalEntity {
      id
      name
      slug
    }
    userEmail
    object {
      __typename
      ... on ReportPackagePreview {
        author {
          ...PublicEntityUserFields
        }
        createdAt
        periodStartedAt
        periodEndedAt
        interval
        title
        coverUrl
        preparedBy
      }
      ... on TransactionPreview {
        ...TransactionPreviewFields
      }
      ... on PartyPreview {
        ...PartyPreviewFields
      }
      ... on CategoryPreview {
        ...CategoryPreviewFields
      }
    }
  }
}
    ${PublicEntityUserFieldsFragmentDoc}
${TransactionPreviewFieldsFragmentDoc}
${PartyPreviewFieldsFragmentDoc}
${CategoryPreviewFieldsFragmentDoc}`;

/**
 * __usePreviewShareQuery__
 *
 * To run a query within a React component, call `usePreviewShareQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewShareQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      id: // value for 'id'
 *      intentId: // value for 'intentId'
 *   },
 * });
 */
export function usePreviewShareQuery(baseOptions: Apollo.QueryHookOptions<PreviewShareQuery, PreviewShareQueryVariables> & ({ variables: PreviewShareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewShareQuery, PreviewShareQueryVariables>(PreviewShareDocument, options);
      }
export function usePreviewShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewShareQuery, PreviewShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewShareQuery, PreviewShareQueryVariables>(PreviewShareDocument, options);
        }
export function usePreviewShareSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewShareQuery, PreviewShareQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewShareQuery, PreviewShareQueryVariables>(PreviewShareDocument, options);
        }
export type PreviewShareQueryHookResult = ReturnType<typeof usePreviewShareQuery>;
export type PreviewShareLazyQueryHookResult = ReturnType<typeof usePreviewShareLazyQuery>;
export type PreviewShareSuspenseQueryHookResult = ReturnType<typeof usePreviewShareSuspenseQuery>;
export type PreviewShareQueryResult = Apollo.QueryResult<PreviewShareQuery, PreviewShareQueryVariables>;
export const PublicDocumentDownloadUrlDocument = gql`
    query PublicDocumentDownloadUrl($documentId: String!, $referenceId: String!) {
  publicDocumentDownloadUrl(documentId: $documentId, referenceId: $referenceId) {
    url
  }
}
    `;

/**
 * __usePublicDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `usePublicDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicDocumentDownloadUrlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function usePublicDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables> & ({ variables: PublicDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>(PublicDocumentDownloadUrlDocument, options);
      }
export function usePublicDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>(PublicDocumentDownloadUrlDocument, options);
        }
export function usePublicDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>(PublicDocumentDownloadUrlDocument, options);
        }
export type PublicDocumentDownloadUrlQueryHookResult = ReturnType<typeof usePublicDocumentDownloadUrlQuery>;
export type PublicDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof usePublicDocumentDownloadUrlLazyQuery>;
export type PublicDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof usePublicDocumentDownloadUrlSuspenseQuery>;
export type PublicDocumentDownloadUrlQueryResult = Apollo.QueryResult<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>;
export const ReadInvitationDocument = gql`
    query ReadInvitation($token: String!) {
  readInvitation(token: $token) {
    id
    recipient {
      givenName
      familyName
      emailAddress
    }
    sender {
      givenName
      avatarUrl
      emailAddress
    }
    organization {
      id
      slug
      name
    }
    service
    invitationType
    organizationTemplateId
    legalEntityRoles {
      legalEntityId
    }
  }
  readInvitationRecipient(token: $token) {
    userId
    givenName
    familyName
    emailAddress
    avatarUrl
  }
}
    `;

/**
 * __useReadInvitationQuery__
 *
 * To run a query within a React component, call `useReadInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInvitationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReadInvitationQuery(baseOptions: Apollo.QueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables> & ({ variables: ReadInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
      }
export function useReadInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
        }
export function useReadInvitationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
        }
export type ReadInvitationQueryHookResult = ReturnType<typeof useReadInvitationQuery>;
export type ReadInvitationLazyQueryHookResult = ReturnType<typeof useReadInvitationLazyQuery>;
export type ReadInvitationSuspenseQueryHookResult = ReturnType<typeof useReadInvitationSuspenseQuery>;
export type ReadInvitationQueryResult = Apollo.QueryResult<ReadInvitationQuery, ReadInvitationQueryVariables>;
export const ReadInvitationRecipientDocument = gql`
    query ReadInvitationRecipient($token: String!) {
  readInvitationRecipient(token: $token) {
    userId
    givenName
    familyName
    emailAddress
    avatarUrl
  }
}
    `;

/**
 * __useReadInvitationRecipientQuery__
 *
 * To run a query within a React component, call `useReadInvitationRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInvitationRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInvitationRecipientQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReadInvitationRecipientQuery(baseOptions: Apollo.QueryHookOptions<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables> & ({ variables: ReadInvitationRecipientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>(ReadInvitationRecipientDocument, options);
      }
export function useReadInvitationRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>(ReadInvitationRecipientDocument, options);
        }
export function useReadInvitationRecipientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>(ReadInvitationRecipientDocument, options);
        }
export type ReadInvitationRecipientQueryHookResult = ReturnType<typeof useReadInvitationRecipientQuery>;
export type ReadInvitationRecipientLazyQueryHookResult = ReturnType<typeof useReadInvitationRecipientLazyQuery>;
export type ReadInvitationRecipientSuspenseQueryHookResult = ReturnType<typeof useReadInvitationRecipientSuspenseQuery>;
export type ReadInvitationRecipientQueryResult = Apollo.QueryResult<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>;
export const ReadPasswordResetDocument = gql`
    query ReadPasswordReset($resetToken: String!) {
  readPasswordReset(resetToken: $resetToken) {
    isValid
    contact {
      familyName
      givenName
      emailAddress
      avatarUrl
    }
  }
}
    `;

/**
 * __useReadPasswordResetQuery__
 *
 * To run a query within a React component, call `useReadPasswordResetQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadPasswordResetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadPasswordResetQuery({
 *   variables: {
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
export function useReadPasswordResetQuery(baseOptions: Apollo.QueryHookOptions<ReadPasswordResetQuery, ReadPasswordResetQueryVariables> & ({ variables: ReadPasswordResetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>(ReadPasswordResetDocument, options);
      }
export function useReadPasswordResetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>(ReadPasswordResetDocument, options);
        }
export function useReadPasswordResetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>(ReadPasswordResetDocument, options);
        }
export type ReadPasswordResetQueryHookResult = ReturnType<typeof useReadPasswordResetQuery>;
export type ReadPasswordResetLazyQueryHookResult = ReturnType<typeof useReadPasswordResetLazyQuery>;
export type ReadPasswordResetSuspenseQueryHookResult = ReturnType<typeof useReadPasswordResetSuspenseQuery>;
export type ReadPasswordResetQueryResult = Apollo.QueryResult<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>;
export const ReadSsoRequirementDocument = gql`
    query ReadSSORequirement($emailAddress: String!) {
  readSSORequirement(emailAddress: $emailAddress) {
    requiresSSO
    ssoIssuerURL
  }
}
    `;

/**
 * __useReadSsoRequirementQuery__
 *
 * To run a query within a React component, call `useReadSsoRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSsoRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSsoRequirementQuery({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useReadSsoRequirementQuery(baseOptions: Apollo.QueryHookOptions<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables> & ({ variables: ReadSsoRequirementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>(ReadSsoRequirementDocument, options);
      }
export function useReadSsoRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>(ReadSsoRequirementDocument, options);
        }
export function useReadSsoRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>(ReadSsoRequirementDocument, options);
        }
export type ReadSsoRequirementQueryHookResult = ReturnType<typeof useReadSsoRequirementQuery>;
export type ReadSsoRequirementLazyQueryHookResult = ReturnType<typeof useReadSsoRequirementLazyQuery>;
export type ReadSsoRequirementSuspenseQueryHookResult = ReturnType<typeof useReadSsoRequirementSuspenseQuery>;
export type ReadSsoRequirementQueryResult = Apollo.QueryResult<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>;
export const ReadSignupDocument = gql`
    query ReadSignup($id: String!) {
  readSignup(id: $id) {
    ...PublicSignupFields
  }
}
    ${PublicSignupFieldsFragmentDoc}`;

/**
 * __useReadSignupQuery__
 *
 * To run a query within a React component, call `useReadSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSignupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadSignupQuery(baseOptions: Apollo.QueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables> & ({ variables: ReadSignupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
      }
export function useReadSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
        }
export function useReadSignupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
        }
export type ReadSignupQueryHookResult = ReturnType<typeof useReadSignupQuery>;
export type ReadSignupLazyQueryHookResult = ReturnType<typeof useReadSignupLazyQuery>;
export type ReadSignupSuspenseQueryHookResult = ReturnType<typeof useReadSignupSuspenseQuery>;
export type ReadSignupQueryResult = Apollo.QueryResult<ReadSignupQuery, ReadSignupQueryVariables>;
export const ViewInvoiceDocument = gql`
    query ViewInvoice($id: String!) {
  viewInvoice(id: $id) {
    ...ViewInvoiceSummaryFields
  }
}
    ${ViewInvoiceSummaryFieldsFragmentDoc}`;

/**
 * __useViewInvoiceQuery__
 *
 * To run a query within a React component, call `useViewInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewInvoiceQuery(baseOptions: Apollo.QueryHookOptions<ViewInvoiceQuery, ViewInvoiceQueryVariables> & ({ variables: ViewInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewInvoiceQuery, ViewInvoiceQueryVariables>(ViewInvoiceDocument, options);
      }
export function useViewInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewInvoiceQuery, ViewInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewInvoiceQuery, ViewInvoiceQueryVariables>(ViewInvoiceDocument, options);
        }
export function useViewInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewInvoiceQuery, ViewInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewInvoiceQuery, ViewInvoiceQueryVariables>(ViewInvoiceDocument, options);
        }
export type ViewInvoiceQueryHookResult = ReturnType<typeof useViewInvoiceQuery>;
export type ViewInvoiceLazyQueryHookResult = ReturnType<typeof useViewInvoiceLazyQuery>;
export type ViewInvoiceSuspenseQueryHookResult = ReturnType<typeof useViewInvoiceSuspenseQuery>;
export type ViewInvoiceQueryResult = Apollo.QueryResult<ViewInvoiceQuery, ViewInvoiceQueryVariables>;
export const ViewInvoiceFilesDocument = gql`
    query ViewInvoiceFiles($legalEntityId: String!, $id: String!) {
  viewInvoiceFiles(legalEntityId: $legalEntityId, id: $id) {
    ...PublicInvoiceFileFields
  }
}
    ${PublicInvoiceFileFieldsFragmentDoc}`;

/**
 * __useViewInvoiceFilesQuery__
 *
 * To run a query within a React component, call `useViewInvoiceFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewInvoiceFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewInvoiceFilesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewInvoiceFilesQuery(baseOptions: Apollo.QueryHookOptions<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables> & ({ variables: ViewInvoiceFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>(ViewInvoiceFilesDocument, options);
      }
export function useViewInvoiceFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>(ViewInvoiceFilesDocument, options);
        }
export function useViewInvoiceFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>(ViewInvoiceFilesDocument, options);
        }
export type ViewInvoiceFilesQueryHookResult = ReturnType<typeof useViewInvoiceFilesQuery>;
export type ViewInvoiceFilesLazyQueryHookResult = ReturnType<typeof useViewInvoiceFilesLazyQuery>;
export type ViewInvoiceFilesSuspenseQueryHookResult = ReturnType<typeof useViewInvoiceFilesSuspenseQuery>;
export type ViewInvoiceFilesQueryResult = Apollo.QueryResult<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>;
export const LogOutDocument = gql`
    mutation LogOut {
  logOut
}
    `;
export type LogOutMutationFn = Apollo.MutationFunction<LogOutMutation, LogOutMutationVariables>;

/**
 * __useLogOutMutation__
 *
 * To run a mutation, you first call `useLogOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOutMutation, { data, loading, error }] = useLogOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogOutMutation(baseOptions?: Apollo.MutationHookOptions<LogOutMutation, LogOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOutMutation, LogOutMutationVariables>(LogOutDocument, options);
      }
export type LogOutMutationHookResult = ReturnType<typeof useLogOutMutation>;
export type LogOutMutationResult = Apollo.MutationResult<LogOutMutation>;
export type LogOutMutationOptions = Apollo.BaseMutationOptions<LogOutMutation, LogOutMutationVariables>;